<!-- компонент для рисования тарифов в VDS -->
<template><div class="plan-wrapper" :class="{ 'in-view': action === 'view' }">

	<!-- заголовок для формы переустановки -->	
	<div class="w5-component-field-title" v-if="action !== 'create'">&nbsp;</div>

	<!-- селектор группы тарифов -->
	<div v-if="action !== 'create' && Groups && Groups.length > 1" class="w5-vds-plan-list-filter-wrapper plan">
		<div class="w5-vds-plan-list-block">
			<div v-for="group in Groups"
				class="w5-vds-plan-list-item groups"
				:key="group.id"
				:class="{ 'selected': group.id == curGroup, 'not-active-item': group.active === false }"
				@click.prevent.stop="onGroupClick(group)">
				<div class="w5-vds-plan-list-item-up">
					<img :src="APIServerUrl + group.image" class="local-group" />
				</div>
				<div class="w5-vds-plan-list-item-down">
					<strong>{{ group.name | ftc }}</strong>
				</div>
			</div>
		</div>
		<div class="description"><p v-withSafeTags="localeFtc(groupDescription)"></p></div>
	</div>
	<template v-else>
		<div v-if="action !== 'create'" class="margin-top-5"></div>
	</template>

	<!-- селектор тарифов-конструкторов -->
	<div v-if="isSeveralConstructors" class="w5-vds-plan-list-filter-wrapper multi-construct" :class="action">
		<span v-for="el in severalConstructorsList"
			:key="el.id"
			class="w5-vds-plan-list-filter first"
			:class="{
				'active': curValue == el.id || currentMultiConstructorValue[curGroup] == el.id,
				'disabled': !el.enable || !el.active || !isPlanSupportedByTemplate(el.id)
			}"
			@click.prevent.stop="onSeveralConstructorSelect(el.id, el.enable && el.active, el, $event)">
			{{ el.name | ftc }}
		</span>
	</div>

	<!-- сам список тарифов -->
	<div class="w5-vds-plan-list-block">
		<template v-for="item in Items">

			<!-- тариф-конструктор -->
			<div v-if="item && item.id && item.params && item.has_params && params && params[item.id] && (String(item.id) === String(curValue) || String(item.id) === String(currentMultiConstructorValue[curGroup]))" class="construct-plan" :class="{ 'disabled': item.enable === false || !isPlanSupportedByTemplate(item.id), 'in-view': action === 'view', 'multi-construct': isSeveralConstructors }">
				<!-- поля со значениями -->
				<div class="fields-values">
					<template v-for="(obj, prop) in params[item.id]">
						<div class="w5-vds-plan-list-params-item">
							<!-- slider field -->
							<template v-if="obj.type === 'slider'">
								<div class="graph-slider" :key="String(obj.__prop) + '_' + String(item.id)">
									<div class="title">{{ obj.title | ftc }}</div>
									<div class="text-slider">
										<div class="text-slider-field-wrapper">
											<input type="text"
												class="slider-input-field"
												:value="inputFieldValues[obj.__prop]"
												:data-item-id="item.id"
												:data-obj="obj.__prop"
												:ref="'field-' + obj.__prop"
												:disabled="item.enable === false || !isPlanSupportedByTemplate(item.id)"
												:id="String(obj.__prop) + '_' + String(item.id)"
												:name="String(obj.__prop) + '_' + String(item.id)"
												@blur="onSliderFieldBlurNew(obj.__prop, item.id)"
											/>
											<div class="field-postfix-wrapper"><span>{{ calculatorFormatingFieldFor(obj) }}</span></div>
										</div>
										<div v-if="inputFieldErrors[obj.__prop]" class="text-slider-field-error">
											{{ inputFieldErrors[obj.__prop] | ftc }}
										</div>
									</div>
									<div class="slider">
										<vue-slider v-model="obj.value"
											:ref="'slider-' + obj.__prop"
											:min="obj.__realMin <= 0 ? 0 : 1"
											:max="obj.max"
											:duration="0.2"
											:marks="obj.marks"
											:interval="obj.step"
											tooltip="none"
											:disabled="item.enable === false || !isPlanSupportedByTemplate(item.id)"
											:labelStyle="{ fontSize: '9px', fontWeight: 300, color: '#666', top: '2px' }"
											@dragging="manualSliderChanged = false"
											@change="value => sliderDragging(item, obj, value)">
											<template v-slot="{ value: innerValue }">
											    <div class="process-minimum" :style="minRangeWidthStyle(obj)"></div>
											</template>
										</vue-slider>
									</div>
									<div class="cost">
										{{ obj.cost | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span> / 1 {{ obj.for | ftc }}
									</div>
								</div>
							</template>
							<!-- boolean field -->
							<template v-if="obj.type === 'boolean'">
								<div class="checkbox params" :key="String(obj.__prop) + '_' + String(item.id)">
									<div class="w5-boolean-field-wrapper">
										<input type="checkbox" class="w5-checkbox-field" v-model="obj.value" style="display: none" />
										<label class="w5-boolean-label construct-label" @click="booleanChangeHandler(item, obj)">
											{{ obj.title | ftc }}
											<template v-if="obj.hint">
												<span class="hidden-xs params-boolean-hint">{{ obj.hint | ftc }}</span>
												<div class="visible-xs params-boolean-hint">{{ obj.hint | ftc }}</div>
											</template>
										</label>
									</div>
								</div>
							</template>
						</div>
					</template>

				</div>
				<!-- разделитель -->
				<div class="fields-divider"></div>
				<!-- итоги -->
				<div class="itogo-values">
					<div class="values">
						<!-- базовая стоимость -->
						<div v-if="String(item.cost) == String(item.full_cost)" class="itog-item base-cost">
							<div class="itog-item-base-cost">
								<div class="title">{{ (item.description || item.text) | ftc }}</div>
								<div class="value">
									<span class="sm">
										{{ item.cost }}
										<span v-html="localeFtc('main/ruble')"> </span> / {{ item.period_name | ftc }}
									</span>
								</div>
							</div>
							<div v-if="action === 'create' && item && item.data" class="w5-vds-plan-list-params-base">
								<div class="values">
									<span v-for="(item, name, idx) in planBaseValues(item)" :key="'base-values' + idx"><span v-if="idx > 0">, </span>{{ item.title | ftc }} {{ item.value }} {{ calculatorFormatingFieldFor(item) }}</span>
								</div>
							</div>
						</div>
						<div v-else class="itog-item base-cost">
							<div class="itog-item-base-cost">
								<div class="title">{{ (item.description || item.text) | ftc }}</div>
								<div class="value">
									<span class="sm">
										<span class="full-cost">&nbsp;{{ item.full_cost | moneyOnlyNumbers }}&nbsp;<span v-html="localeFtc('main/ruble')"> </span>&nbsp;</span>
										<span>{{ item.cost | moneyOnlyNumbers }}</span>
										<span v-html="localeFtc('main/ruble')"> </span> / {{ item.period_name | ftc }}
									</span>
								</div>
							</div>
							<div v-if="action === 'create' && item && item.data" class="w5-vds-plan-list-params-base">
								<div class="values">
									<span v-for="(item, name, idx) in planBaseValues(item)" :key="'base-values' + idx"><span v-if="idx > 0">, </span>{{ item.title | ftc }} {{ item.value }} {{ calculatorFormatingFieldFor(item) }}</span>
								</div>
							</div>
						</div>

						<div v-if="isVisibleAnyParamsItog(params[item.id])" class="itog-item add-cost">
							{{ 'main/additionally' | ftc }}:
						</div>

						<!-- остальные итоги по услугам -->
						<template v-for="(obj, prop) in params[item.id]">
							<div v-if="isVisibleParamsItog(obj)" class="itog-item">
								<div class="title">
									<template v-if="obj.type === 'boolean'">
										{{ obj.st_name | ftc }} {{ Number(obj.value) }} {{ obj.for ? calculatorFormatingFieldFor(obj) : 'main/sht' | ftc }}
									</template>
									<template v-else>
										{{ obj.st_name | ftc }} {{ Number(obj.value) - obj.__initMin }} {{ obj.for ? calculatorFormatingFieldFor(obj) : 'main/sht' | ftc }}
									</template>
								</div>
								<div class="value">

									<!-- with discount -->
									<template v-if="isDiscountParam(obj)">
										<!-- slider -->
										<span v-if="obj.type === 'slider'" class="sm"><span class="full-cost">&nbsp;{{
											(Number(obj.value) - obj.__initMin) <= 0
												? 0
												: (Number(obj.value) - obj.__initMin) * obj.full_cost
											| moneyOnlyNumbers
										}}&nbsp;<span v-html="localeFtc('main/ruble')"> </span>&nbsp;</span>
										<span>{{
											(Number(obj.value) - obj.__initMin) <= 0
												? 0
												: (Number(obj.value) - obj.__initMin) * obj.cost
											| moneyOnlyNumbers
										}}</span>
										 <span v-html="localeFtc('main/ruble')"> </span> / {{ obj.period_name | ftc }}</span>

										<!-- boolean -->
										<span v-if="obj.type === 'boolean'" class="sm">
											<template v-if="obj.value">
												<span class="full-cost">&nbsp;{{ obj.full_cost | moneyOnlyNumbers }}&nbsp;<span v-html="localeFtc('main/ruble')"> </span>&nbsp;</span>
												<span>{{ obj.cost | moneyOnlyNumbers }}</span> <span v-html="localeFtc('main/ruble')"> </span> / {{ obj.period_name | ftc }}
											</template>
											<span v-else></span>
										</span>
									</template>

									<!-- without discount -->
									<template v-else>
										<!-- slider -->
										<span v-if="obj.type === 'slider'" class="sm">{{
											(Number(obj.value) - obj.__initMin) <= 0
												? 0
												: (Number(obj.value) - obj.__initMin) * obj.cost
											| moneyOnlyNumbers
										}} <span v-html="localeFtc('main/ruble')"> </span> / {{ obj.period_name | ftc }}</span>

										<!-- boolean -->
										<span v-if="obj.type === 'boolean'" class="sm">
											<template v-if="obj.value">
												{{ obj.cost | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span> / {{ obj.period_name | ftc }}
											</template>
											<span v-else></span>
										</span>
									</template>
								</div>
							</div>
						</template>

						<!-- итоги по IP-адресам -->
						<template v-if="ipInfo">
							<template v-if="isDiscountIp()">
								<template v-if="ipInfo.ip4 && ipInfo.ip4.title && ipInfo.ip4.count">
									<div class="itog-item">
										<div class="title">
											{{ ipInfo.ip4.title | ftc }} {{ ipInfo.ip4.count }} {{ ipInfo.ip4.for | ftc }}
										</div>
										<div class="value">
											<span class="sm">
												<span v-if="ipInfo.ip4.full_cost" class="full-cost">&nbsp;{{ ipInfo.ip4.full_cost | moneyOnlyNumbers }}&nbsp;<span v-html="localeFtc('main/ruble')"> </span>&nbsp;</span>
												<span>{{ ipInfo.ip4.cost | moneyOnlyNumbers }}</span> <span v-html="localeFtc('main/ruble')"> </span> / {{ ipInfo.ip4.period | ftc }}
											</span>
										</div>
									</div>
								</template>
								<template v-if="ipInfo.ip6 && ipInfo.ip6.title && ipInfo.ip6.count">
									<div class="itog-item">
										<div class="title">
											{{ ipInfo.ip6.title | ftc }} {{ ipInfo.ip6.count }} {{ ipInfo.ip6.for | ftc }}
										</div>
										<div class="value">
											<span class="sm">
												<span v-if="ipInfo.ip6.full_cost" class="full-cost">&nbsp;{{ ipInfo.ip6.full_cost | moneyOnlyNumbers }}&nbsp;<span v-html="localeFtc('main/ruble')"> </span>&nbsp;</span>
												<span>{{ ipInfo.ip6.cost | moneyOnlyNumbers }}</span> <span v-html="localeFtc('main/ruble')"> </span> / {{ ipInfo.ip6.period | ftc }}
											</span>
										</div>
									</div>
								</template>
							</template>
							<template v-else>
								<template v-if="ipInfo.ip4 && ipInfo.ip4.title && ipInfo.ip4.count">
									<div class="itog-item">
										<div class="title">
											{{ ipInfo.ip4.title | ftc }} {{ ipInfo.ip4.count }} {{ ipInfo.ip4.for | ftc }}
										</div>
										<div class="value">
											<span class="sm">
												<span>{{ ipInfo.ip4.cost | moneyOnlyNumbers }}</span> <span v-html="localeFtc('main/ruble')"> </span> / {{ ipInfo.ip4.period | ftc }}
											</span>
										</div>
									</div>
								</template>
								<template v-if="ipInfo.ip6 && ipInfo.ip6.title && ipInfo.ip6.count">
									<div class="itog-item">
										<div class="title">
											{{ ipInfo.ip6.title | ftc }} {{ ipInfo.ip6.count }} {{ ipInfo.ip6.for | ftc }}
										</div>
										<div class="value">
											<span class="sm">
												<span>{{ ipInfo.ip6.cost | moneyOnlyNumbers }}</span> <span v-html="localeFtc('main/ruble')"> </span> / {{ ipInfo.ip6.period | ftc }}
											</span>
										</div>
									</div>
								</template>
							</template>
						</template>
					</div>
					<div class="itogo">
						<div class="header">{{ 'chart/total' | ftc }}:</div>
						<div class="value">
							<!-- with discount -->
							<template v-if="isDiscountPlan(item)">
								<span class="full-cost">&nbsp;{{ paramsPlanItogo(item, 'full_cost') | moneyOnlyNumbers }}&nbsp;<span v-html="localeFtc('main/ruble')"> </span>&nbsp;</span>
								<span>{{ paramsPlanItogo(item) | moneyOnlyNumbers }}</span> <span v-html="localeFtc('main/ruble')"> </span> / {{ item.period_name | ftc }}
							</template>
							<!-- without discount -->
							<template v-else>
								{{ paramsPlanItogo(item) | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span> / {{ item.period_name | ftc }}
								<br>
								{{ 30.0 * paramsPlanItogo(item, 'cost', false) | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span> / {{ 'main/month' | ftc }}
							</template>
						</div>
					</div>
				</div>
				
			</div>

			<!-- простой тариф -->
			<template v-else-if="item && item['data'] && !item.has_params">
				<div class="w5-vds-plan-list-item"
					:key="item.id"
					:class="{
						'selected': item.id == curValue,
						'disabled': item.enable === false || !isPlanSupportedByTemplate(item.id),
						'w5-vds-plan-not-active': !isItemActive(item)
					}"
					@click.prevent.stop="onItemClick(item.id, item.enable, item)">
					<div class="w5-vds-plan-list-item-up">
						<span v-withSafeTags="localeFtc(planAdditionalText(item))"></span>
						<strong>{{ item['data']['cpu']['value'] | moneyOnlyNumbers }} {{ item['data']['cpu']['for'] | ftc }}</strong> / {{ item['data']['cpu']['title'] | ftc }}
						<br>
						<strong>{{ item['data']['ram']['value'] | moneyOnlyNumbers }} {{ item['data']['ram']['for'] | ftc }}</strong> / {{ item['data']['ram']['title'] | ftc }}
						<br>
						<strong>{{ item['data']['disk']['value'] | moneyOnlyNumbers }} {{ item['data']['disk']['for'] | ftc }}</strong> / {{ item['data']['disk']['title'] | ftc }}
						<br>
						<strong>{{ item['data']['traff']['value'] | moneyOnlyNumbers }} {{ item['data']['traff']['for'] | ftc }}</strong> / {{ item['data']['traff']['title'] | ftc }}
					</div>
					<div class="w5-vds-plan-list-item-down">
						<!-- with discount -->
						<template v-if="isDiscountPlan(item)">
							<strong><span class="full-cost">&nbsp;{{ item['full_cost'] | moneyOnlyNumbers }}&nbsp;<span v-html="localeFtc('main/ruble')"> </span>&nbsp;</span>{{ item['cost'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></strong> / {{ item['period_name'] | ftc }}
						</template>
						<!-- without discount -->
						<template v-else>
							<strong>{{ item['cost'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></strong> / {{ item['period_name'] | ftc }}
						</template>
					</div>
				</div>
			</template>

		</template>
	</div>

</div></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import { EventBus } from '@/bus.js'
import Helper from '@/helper/helper'
import debounce from 'debounce'
import 'autonumeric'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'planComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['items', 'value', 'action', 'groups', 'groupValue', 'cookieValue', 'templateField', 'ipInfo'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// текущий выбранный тариф
			curValue: null,
			// текущая выбранная группа тарифов
			curGroup: null,
			// текущий шаблон
			curTemplate: null,
			// список допустимых тарифов для текущего шаблона
			availablePlans: null,
			// текущие данные тарифа-конструктора
			params: null,
			// закешированные данные тарифа-конструктора
			paramsCached: {},
			// таймер для обновления слайдеров тарифа-конструктора
			sliderTimerHandler: null,
			// значения полей
			inputFieldValues: {
				cpu: 0,
				ram: 0,
				disk: 0,
				gpu: 0
			},
			// ошибки полей
			inputFieldErrors: {
				cpu: '',
				ram: '',
				disk: '',
				gpu: ''
			},

			manualSliderChanged: false,

			// для инициализации кук - нужно считать
			initValueCounter: 0,

			// флаг в редактировании ВДС - если было первое изменени
			// и мы сделали перерасчет для всех слайдеров
			isSlidersWasRecounted: false,

			// текущее значение мультиконструктора для каждой группы тарифов
			currentMultiConstructorValue: {}
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// отфильтрованный список групп тарифов
		Groups() {
			if (!this.groups || !this.groups.length)
				return null

			return this.groups.filter(g => {
				// если точно неактивен
				if (g.active === false)
				{
					// сотрудникам все показываем
					if (this.$store.state.user_type === 'admin')
						return true
					// клиентам такие точно не показываем
					else
						return false
				}

				// любой другой случай (например когда вообще нет флага)
				return true
			})
		},

		// список тарифов, отфильтрованный по группе
		Items() {
			// если это просмотр - возвращаем все как есть
			if (this.action === 'view')
			{
				return this.items && this.items.length
					? this.items
					: []
			}

			// иначе фильтруем
			if (!this.items || !this.items.length) return []
			return this.items.filter(item => {
				if (item.plan_group === this.curGroup)
				{
					// 1. если нет фага - такие тарифы рисуем все
					if (!('active' in item)) return true
					// 2. если это сотрудник
					if (this.$store.state.user_type === 'admin')
					{
						// если тариф это конструктор
						if (item.has_params)
						{
							// рисуем в зависимости от флага
							return item.active === true
						}
						// иначе - рисуем все тарифы
						return true
					}
					// 3. если это клиент - рисуем только активные тарифы
					return item.active === true
				}

				return false
			})
		},

		// описание группы тарифов
		groupDescription() {
			if (!this.groups || !this.groups.length) return

			let desc = ''
			this.groups.some(group => {
				if (this.curGroup === group.id)
				{
					desc = group.description
					return true
				}
			})

			return desc
		},

		// несколько активных конструкторов
		isSeveralConstructors() {
			if (!this.Items || !this.Items.length) return false

			let count = 0
			for (let i = 0; i < this.Items.length; i++)
			{
				if (this.Items[i] &&
					this.Items[i].id &&
					this.Items[i].has_params &&
					this.isItemActive(this.Items[i]))
				{
					count++
					if (count > 1) return true
				}
			}

			return false
		},

		// список несколько конструкторов - тут может быть и один тариф
		severalConstructorsList() {
			if (!this.Items || !this.Items.length) return []

			const answer = []
			for (let i = 0; i < this.Items.length; i++)
			{
				if (this.Items[i].has_params)
				{
					answer.push(this.Items[i])
				}
			}

			return answer
		},

		// показываемое значение верхней вкладки для мобильников
		mobileShowUpperTab() {
			if (!this.isSeveralConstructors ||
				!this.severalConstructorsList ||
				!this.severalConstructorsList.length)
			{
				return ''
			}

			// нужно найти тариф
			for (let i = 0; i < this.severalConstructorsList.length; i++)
			{
				if (String(this.severalConstructorsList[i].id) === String(this.curValue))
				{
					return this.severalConstructorsList[i].name
				}
			}

			// по умолчанию
			return ''
		}
	},
	//=========================================================================
	// функция, которая будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// debounce функции изменения значения тарифа конструктора в поле
		this.onSliderFieldChangeNew = debounce(this.onSliderFieldChangeNew, 20)
		// установим значение группы
		this.curGroup = this.formater_StrToInt(this.groupValue)

		// если это просмотр VDS
		if (this.action === 'view')
		{
			// по идее - уже должно быть задано значение родителем
			if (this.value) this.curValue = String(this.value)
			else
			{
				// ищем первый доступный тариф
				if (this.Items && this.Items.length)
				{
					this.Items.some(item => {
						if (item && item.active && item.enable && item.id)
						{
							// выбираем новое значение
							this.curValue = String(item.id)
							// сообщаем родителю что у нас поменялось значение
							this.$emit('input', this.curValue)
							return true
						}
					})
				}
			}

			// в просмотре шаблон сразу задан
			if (this.templateField && this.templateField.value && this.templateField.list && this.templateField.list.length)
			{
				this.templateField.list.some(t => {
					if (t && String(t.id) === String(this.templateField.value))
					{
						this.curTemplate = Object.assign({}, t)
						this.availablePlans = []

						if (t.plans)
						{
							if (Array.isArray(t.plans) && t.plans.length)
							{
								this.availablePlans = t.plans.slice()
							}
							else
							{
								for (let prop in t.plans)
								{
									if (t.plans.hasOwnProperty(prop))
									{
										this.availablePlans.push(t.plans[prop])
									}
								}
							}
						}
					}
				})
			}

			// инициализируем
			this.initValue(false)

			// если текущий тариф - это конструктор
			if (this.params && this.params[this.curValue])
			{
				// даем сигнал что он пока еще неизменялся
				EventBus.$emit('w5-plan-constructor-changed', false)
			}
		}

		// подписка на изменение выбранного шаблона ОС
		EventBus.$on('w5-new-vds-template-notice-what', this.handleTemplateChanged)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от сообщений
		EventBus.$off('w5-new-vds-template-notice-what', this.handleTemplateChanged)

		// обнуляем таймер
		if (this.sliderTimerHandler)
		{
			clearTimeout(this.sliderTimerHandler)
			this.sliderTimerHandler = null
		}

		// удаляем обработчики
		$('.slider-input-field').each(function(idx) {
			try {
				$(this).off('keydown')
				$(this).off('keyup')
				$(this).off('blur')
				$(this).autoNumeric('destroy')
			}
			catch (e) {}
		})
	},
	//=========================================================================
	// компонент смонтирован в DOM
	//=========================================================================
	mounted() {
		if (this.action === 'view')
		{
			this.setHandles()
		}
	},
	//=========================================================================
	// компонент обновился
	//=========================================================================
	updated() {
		this.setHandles()
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// описание тарифа
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		planAdditionalText(item) {
			if (!item || !item.id || !item.description || item.has_params) return ''
			return item.description + '<br>'
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// форматирование едениц в калькуляторе
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		calculatorFormatingFieldFor(field) {
			let _title = String(field.title).toLowerCase()

			if (_title === 'ram' || _title === 'память') return this.localeFtc(field.for) + ' RAM'
			else if (_title === 'nvme' || _title === 'хранилище') return this.localeFtc(field.for) + ' NVMe'

			return this.localeFtc(field.for)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по группе тарифов
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onGroupClick(group) {
			// обновим кеш конструктора
			if (this.params && this.params[this.curValue])
				this.paramsCached[this.curValue] = Object.assign({}, this.params[this.curValue])
			// эмуляция фокуса
			this.$emit('focus')
			// запоминаем новое значение
			this.curGroup = group.id
			// сообщаем родителю что у нас поменялось значение по группе
			this.$emit('groupChanged', this.curGroup)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по тарифу
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onItemClick(id, enable, Item) {
			// эмуляция фокуса
			this.$emit('focus')
			// если заблокировано
			if (!enable) return

			// проверка флагов
			if (Item.enable === false || !this.isPlanSupportedByTemplate(Item.id))
				return

			// запоминаем новое значение
			this.curValue = String(id)
			// сообщаем родителю что у нас поменялось значение по тарифу
			this.$emit('input', this.curValue)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// инициализация начального значения
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		initValue(withSelect = true) {
			// считаем
			this.initValueCounter++

			// если это создание вдс
			let _cookieParams = null
			if (this.action === 'create')
			{
				// смотрим - может есть параметры в куке
				let _cookie = Helper.getCookie('crtvdsplanparams')
				// удалим
				if (this.initValueCounter > 1) Helper.deleteCookie('crtvdsplanparams')

				// если такая кука есть
				if (_cookie)
				{
					// конвертируем
					try {
						_cookieParams = JSON.parse(_cookie)
					}
					catch (e)
					{
						_cookieParams = null
					}
				}
			}

			// инициализируем поля params - если есть тарифы
			if (this.items && this.items.length)
			{
				// бежим по каждому тарифу
				this.items.forEach(item => {
					// если они содержит параметры для конструктора
					if (item.params && item.id)
					{
						// если поле еще не создано
						if (!this.params) this.params = {}

						// формируем для текущего тарифа
						if (!this.params[item.id]) this.params[item.id] = {}
						// каждое поле - объект
						for (let prop in item.params)
						{
							// для сортировки в порядке поля "order"
							let name = String(item.params[prop].order)
							if (name.length <= 1) name = '0' + name

							this.params[item.id][name] = Object.assign({}, item.params[prop])
							this.params[item.id][name].__prop = prop

							if (item.params[prop].type === 'slider')
							{
								// реальный минимум - ниже которого значение не должно быть
								this.params[item.id][name].__realMin = item.params[prop].min
								this.params[item.id][name].__initMin = Math.min(item.params[prop].min, item.data && item.data[prop] && 'value' in item.data[prop] ? item.data[prop].value : 0)

								// если значение не указано
								if (!this.params[item.id][name].value)
								{
									// если есть в кеше
									if (this.paramsCached &&
										this.paramsCached[item.id] &&
										this.paramsCached[item.id][name] &&
										this.paramsCached[item.id][name].value)
									{
										this.params[item.id][name].value = this.paramsCached[item.id][name].value
									}
									// если в кеше нет - ставим текущим значением минимум
									else
									{
										this.params[item.id][name].value = item.params[prop].min
										this.params[item.id][name].__initValue = this.params[item.id][name].value
									}
								}
								else
								{
									this.params[item.id][name].__initValue = this.params[item.id][name].value
								}

								// если есть значение из куки
								if (_cookieParams &&
									typeof _cookieParams === 'object' &&
									prop in _cookieParams)
								{
									if (_cookieParams[prop] >= item.params[prop].min &&
										_cookieParams[prop] <= item.params[prop].max)
									{
										this.params[item.id][name].value = _cookieParams[prop]
										this.params[item.id][name].__initValue = this.params[item.id][name].value
									}
								}

								// копируем значение в текстовое поле
								// this.inputFieldValues[prop] = this.params[item.id][name].value

								// шкала
								if (prop === 'cpu' || prop === 'ram' || prop === 'disk')
								{
									if (item.params[prop].max > 0)
									{
										// шкала
										let delta = Math.floor(item.params[prop].max / 4)
										this.params[item.id][name].marks = value => {
											if (value === 0) return this.params[item.id][name].__realMin === 0
											if (value === 1) return this.params[item.id][name].__realMin > 0
											if (value === item.params[prop].max) return true

											if (value % delta === 0 && (value + delta) <= item.params[prop].max) return true

											return false
										}
									}
								}
								else
								{
									if (item.params[prop].max > 0)
									{
										// шкала
										let delta = 1
										this.params[item.id][name].marks = value => {
											if (value === 0) return this.params[item.id][name].__realMin === 0
											if (value === item.params[prop].max) return true

											if (value % delta === 0 && (value + delta) <= item.params[prop].max) return true

											return false
										}
									}
								}
							}
							else if (item.params[prop].type === 'boolean')
							{
								if (!('value' in this.params[item.id][name]))
								{
									if (this.paramsCached &&
										this.paramsCached[item.id] &&
										this.paramsCached[item.id][name] &&
										'value' in this.paramsCached[item.id][name])
										this.params[item.id][name].value = this.paramsCached[item.id][name].value
									else
										this.params[item.id][name].value = true
								}
								else
								{
									this.params[item.id][name].__initValue = this.params[item.id][name].value
								}
							}
						}
					}
				})
			}

			// определим тариф по умолчанию
			let first = null
			let selected = null
			let initPlan = null
			let emitParams = false

			// нужно ли искать "selected"
			let needSelected = false
			if (withSelect) needSelected = true

			// начинаем поиск подходящего тарифа
			if (this.Items && this.Items.length)
			{
				// бежим по всем тарифам
				this.Items.forEach(item => {
					// определяем самый первый активный, если он еще не определен
					if (!first &&
						item.id &&
						this.isItemActive(item) &&
						this.isPlanSupportedByTemplate(item.id))
					{
						initPlan = item
						first = String(item.id)
					}

					// если это редактирование
					if (this.action === 'view' && String(item.id) === String(this.value))
					{
						selected = String(item.id)
						emitParams = true
					}

					// определяем выбранный по умолчанию с флагом "selected"
					if (needSelected)
					{
						if (item.selected === true && item.id && this.isItemActive(item) && this.isPlanSupportedByTemplate(item.id))
						{
							initPlan = item
							selected = String(item.id)
						}
					}
				})
			}

			// если так и не выбрали
			if (!first && !selected)
			{
				// ищем в текущем списке конструктор - может можно его подкрутить под шаблон
				if (this.curTemplate && this.Items && this.Items.length)
				{
					let construct = null
					this.Items.some(item => {
						if (item && item.has_params && item.params && item.active && item.enable)
						{
							construct = item
							return true
						}
					})

					// если нашли конструктор и он есть как минимум в списке поддерживаемых
					if (construct && this.curTemplate.plans && this.curTemplate.plans.length && this.curTemplate.plans.indexOf(construct.id) > -1)
					{
						// запомним для установки
						first = String(construct.id)
						// пробуем подкрутить - установкой минимумов и текущего значения
						this.restoreConstructMins(construct)
						// флаг - что нужно сообщить о том что поменялся тариф
						// например при смене группы тарифов - нужно что бы поле автобэкапа получило текущие данные
						emitParams = true
					}
				}
			}
			else
			{
				// если это конструктор
				if (initPlan && initPlan.has_params)
				{
					// пробуем подкрутить - установкой минимумов и текущего значения
					this.restoreConstructMins(initPlan)
				}
			}

			// определяем выбранный сайтом - смотрим на значение куки
			let choicedByCookie = this.cookieValue ? String(this.cookieValue) : null
			if (!needSelected) choicedByCookie = null

			// по умолчанию тариф не выбран
			this.curValue = null
			// установим значение - сначала если есть кука
			if (choicedByCookie) this.curValue = choicedByCookie
			// потом смотрим на дефолтное значение
			else if (selected) this.curValue = selected
			// если ничего нет - первый из списка
			else this.curValue = first

			// если это мультиконструктор и есть запомненое значение мультиконструктора
			if (this.isSeveralConstructors &&
				this.currentMultiConstructorValue &&
				this.curGroup in this.currentMultiConstructorValue)
			{
				// ставим уже запомненое значение
				this.curValue = this.currentMultiConstructorValue[this.curGroup]
			}

			// копируем значение в текстовое поле
			if (this.params && this.curValue && this.params[this.curValue])
			{
				for (let name in this.params[this.curValue])
				{
					const param = this.params[this.curValue][name]
					if (param.type === 'slider' && param.value)
					{
						this.inputFieldValues[param.__prop] = param.value
					}
				}
			}

			// сообщим родителю
			this.$emit('params', this.params && this.curValue && this.params[this.curValue] ? this.params[this.curValue] : null)
			this.$emit('input', this.curValue)
			this.$emit('startData', this.curValue)
			if (emitParams) this.$nextTick(() => this.handleEvent())
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// восстанавливает минимумы у конструктора
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		restoreConstructMins(construct) {
			if (construct &&
				this.curTemplate &&
				this.curTemplate.plans &&
				this.curTemplate.plans.length &&
				this.curTemplate.plans.indexOf(construct.id) > -1)
			{
				// пробуем подкрутить - установкой минимумов и текущего значения
				// если есть лимиты
				if (this.curTemplate && this.curTemplate.limits &&
					this.curTemplate.limits.cpu && 'min' in this.curTemplate.limits.cpu &&
					this.curTemplate.limits.ram && 'min' in this.curTemplate.limits.ram &&
					this.curTemplate.limits.disk && 'min' in this.curTemplate.limits.disk)
				{
					// cpu
					let _field = this.findParamsField(construct, 'cpu')
					if (_field)
					{
						if (_field.min !== this.curTemplate.limits.cpu.min)
							_field.min = Math.max(_field.min, this.curTemplate.limits.cpu.min)
						//if (_field.value < _field.min)
						if (_field.value < _field.min && this.action !== 'view')
						{
							_field.value = _field.min
							this.inputFieldValues['cpu'] = _field.value
						}
					}
					// ram
					_field = this.findParamsField(construct, 'ram')
					if (_field)
					{
						if (_field.min !== this.curTemplate.limits.ram.min)
							_field.min = Math.max(_field.min, this.curTemplate.limits.ram.min)
						//if (_field.value < _field.min)
						if (_field.value < _field.min && this.action !== 'view')
						{
							_field.value = _field.min
							this.inputFieldValues['ram'] = _field.value
						}
					}
					// gpu
					_field = this.findParamsField(construct, 'gpu')
					if (_field && this.curTemplate.limits.gpu && 'min' in this.curTemplate.limits.gpu)
					{
						if (_field.min !== this.curTemplate.limits.gpu.min)
							_field.min = Math.max(_field.min, this.curTemplate.limits.gpu.min)
						//if (_field.value < _field.min)
						if (_field.value < _field.min && this.action !== 'view')
						{
							_field.value = _field.min
							this.inputFieldValues['gpu'] = _field.value
						}
					}
					// disk
					_field = this.findParamsField(construct, 'disk')
					if (_field)
					{
						if (_field.min !== this.curTemplate.limits.disk.min)
							_field.min = Math.max(_field.min, this.curTemplate.limits.disk.min)
						//if (_field.value < _field.min)
						if (_field.value < _field.min && this.action !== 'view')
						{
							_field.value = _field.min
							this.inputFieldValues['disk'] = _field.value
						}
					}
				}
				// если лимитов нет
				else
				{
					// ничего подкручивать не нужно - просто восстановим минимумы в другом месте
				}

				this.$nextTick(() => this.$forceUpdate())
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// спрашивают - какой тариф выбран
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		handleEvent() {
			// найдем текущий тариф
			let found = null
			if (this.Items && this.Items.length)
			{
				this.Items.some(plan => {
					if (plan && String(plan.id) === String(this.curValue))
					{
						found = Object.assign({}, plan)
						return true
					}
				})
			}

			// если это конструктор - передадим текущие выбранные данные
			if (found && found.data &&
				found.data.cpu && typeof found.data.cpu === 'object' &&
				found.data.disk && typeof found.data.disk === 'object' &&
				found.data.ram && typeof found.data.ram === 'object' &&
				this.params && this.params[found.id])
			{
				for (let numProp in this.params[found.id])
				{
					let prop = this.params[found.id][numProp]['__prop']
					if (found.data[prop])
					{
						found.data[prop].value = this.params[found.id][numProp].value
					}
				}
			}
			// отвечаем
			EventBus.$emit('w5-new-vds-plan-notice', {
				id: this.curValue,
				plan: found
			})
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// выбрали какой то шаблон ОС
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		handleTemplateChanged(template) {
			// если это просмотр VDS - то не реагируем
			if (this.action === 'view') return

			// обнулим выбранный шаблон
			this.curTemplate = null
			// обнулим список допустимых тарифов
			this.availablePlans	= null

			// если пришел шаблон
			if (template)
			{
				// в любом случае запомним его
				this.curTemplate = template
				// если с ним идет список допустымх тарифов
				if (template.plans)
				{
					if (Array.isArray(template.plans) && template.plans.length)
					{
						// копируем его отдельно - для удобства и совместимости старого кода
						this.availablePlans = template.plans.slice()
					}
					else
					{
						this.availablePlans = []

						for (let prop in template.plans)
						{
							if (template.plans.hasOwnProperty(prop))
							{
								this.availablePlans.push(template.plans[prop])
							}
						}
					}
				}
				// если это ISO
				else if (template.__type === 'iso')
				{
					// включаем весь текущий список тарифов
					this.availablePlans = this.Items.map(i => parseInt(i.id, 10))
					this.curTemplate.plans = this.availablePlans
				}
			}
			else
			{
				// пришел пустой шаблон - переинициализируем тариф
				this.initValue()
				return
			}

			// если поддерживается текущий тариф новым шаблоном
			if (this.isPlanSupportedByTemplate(this.curValue))
			{
				// обязательно восстановим минимумы если это конструктор
				// найдем текущий тариф
				if (this.Items && this.Items.length)
				{
					let construct = null
					this.Items.some(item => {
						if (item && item.has_params && item.params && item.active && item.enable && String(item.id) === this.curValue)
						{
							construct = item
							return true
						}
					})

					// если нашли конструктор
					if (construct)
					{
						// определяем минимумы
						let cpuMin = 1
						let ramMin = 1
						let diskMin = 1
						let gpuMin = 0

						// а у шаблона есть лимиты?
						// если есть лимиты
						// сначала из самого тарифа
						if (construct.params &&
							construct.params.cpu && 'min' in construct.params.cpu &&
							construct.params.ram && 'min' in construct.params.ram &&
							construct.params.disk && 'min' in construct.params.disk)
						{
							cpuMin = construct.params.cpu.min
							ramMin = construct.params.ram.min
							diskMin = construct.params.disk.min
						}

						if (construct.params &&
							construct.params.gpu && 'min' in construct.params.gpu)
						{
							gpuMin = construct.params.gpu.min
						}

						// если еще есть лимиты
						if (this.curTemplate && this.curTemplate.limits &&
							this.curTemplate.limits.cpu && 'min' in this.curTemplate.limits.cpu &&
							this.curTemplate.limits.ram && 'min' in this.curTemplate.limits.ram &&
							this.curTemplate.limits.disk && 'min' in this.curTemplate.limits.disk)
						{
							// минимумы переопределяются
							cpuMin = Math.max(this.curTemplate.limits.cpu.min, construct.params.cpu.min)
							ramMin = Math.max(this.curTemplate.limits.ram.min, construct.params.ram.min)
							diskMin = Math.max(this.curTemplate.limits.disk.min, construct.params.disk.min)
						}

						if (this.curTemplate && this.curTemplate.limits &&
							this.curTemplate.limits.gpu && 'min' in this.curTemplate.limits.gpu)
						{
							// минимумы переопределяются
							gpuMin = Math.max(this.curTemplate.limits.gpu.min, gpuMin)
						}

						// смотрим минимумы
						let _valueChanged = false
						// cpu
						let _field = this.findParamsField(construct, 'cpu')
						if (_field)
						{
							if (_field.min !== cpuMin)
								_field.min = cpuMin
							if (_field.value < _field.min)
							{
								_field.value = _field.min
								this.inputFieldValues['cpu'] = _field.value
								_valueChanged = true
							}
						}
						// ram
						_field = this.findParamsField(construct, 'ram')
						if (_field)
						{
							if (_field.min !== ramMin)
								_field.min = ramMin
							if (_field.value < _field.min)
							{
								_field.value = _field.min
								this.inputFieldValues['ram'] = _field.value
								_valueChanged = true
							}
						}
						// gpu
						_field = this.findParamsField(construct, 'gpu')
						if (_field)
						{
							if (_field.min !== gpuMin)
								_field.min = gpuMin
							if (_field.value < _field.min)
							{
								_field.value = _field.min
								this.inputFieldValues['gpu'] = _field.value
								_valueChanged = true
							}
						}
						// disk
						_field = this.findParamsField(construct, 'disk')
						if (_field)
						{
							if (_field.min !== diskMin)
								_field.min = diskMin
							if (_field.value < _field.min)
							{
								_field.value = _field.min
								this.inputFieldValues['disk'] = _field.value
								_valueChanged = true
							}
						}

						// если были изменения
						if (_valueChanged && this.params && this.params[this.curValue])
						{
							// обновим кеш
							this.paramsCached[this.curValue] = Object.assign({}, this.params[this.curValue])
							// сообщаем всем что поменялся тариф
							this.handleEvent()
							// сообщаем родителю что у нас поменялось значение по тарифу
							this.$emit('params', this.params[this.curValue])
						}

						this.$nextTick(() => this.$forceUpdate())
					}
				}

				return
			}

			// для остальных нужно сделать переинициализацию
			this.initValue(false)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// активный тариф или нет
		// active = true – тариф в принципе активен и его видно клиенту.
		// active = false – тариф заблокирован, его не видно клиенту, но видно сотруднику.
		// enable = true –тариф можно заказать или перейти на него.
		// enable = false – тариф нельзя заказать или перейти на него, должен быть засерен.
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isItemActive(item) {
			if ('active' in item) return item.active
			return true
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// поддерживается тариф шаблоном или нет
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isPlanSupportedByTemplate(planId) {
			// если не задан ID тарифа
			if (!planId) return false

			// если нет данных о шаблоне
			if (!this.curTemplate || !this.availablePlans || !this.availablePlans.length)
			{
				return false
			}

			// найдем данные тарифа
			let _data = null
			if (this.Items && this.Items.length)
			{
				this.Items.some(plan => {
					if (plan && plan.data && String(plan.id) === String(planId))
					{
						// если это конструктор
						if (plan.has_params && this.params[plan.id])
						{
							// эмулируем данные тарифа
							_data = {
								cpu: this.params[plan.id]['01'],
								ram: this.params[plan.id]['02'],
								disk: this.params[plan.id]['03'],
								has_params: true
							}
						}
						else
						{
							// просто копируем даные из данных тарифа
							_data = plan.data
						}

						// так же скопируем ID тарифа
						_data.id = plan.id

						return true
					}
				})
			}

			// если не нашли такого
			if (!_data)
			{
				return false
			}

			// если текущий тариф поддерживается новым шаблоном
			let _isAvailablePlan = false
			if (this.availablePlans && this.availablePlans.length)
			{
				this.availablePlans.some(k => {
					if (String(k) === String(_data.id))
					{
						_isAvailablePlan = true
						return true
					}
				})
			}

			if (_isAvailablePlan || this.curTemplate.__type === 'iso')
			{
				// если у нового шаблона есть лимиты
				if (this.curTemplate && this.curTemplate.limits &&
					this.curTemplate.limits.cpu && 'min' in this.curTemplate.limits.cpu &&
					this.curTemplate.limits.ram && 'min' in this.curTemplate.limits.ram &&
					this.curTemplate.limits.disk && 'min' in this.curTemplate.limits.disk)
				{
					// если нет данных текущего тарифа
					if (!_data.cpu || !_data.disk || !_data.ram)
					{
						return false
					}

					// если это конструктор
					if (_data.has_params)
					{
						// теперь нужно давать менять всегда параметры - даже если текущие данные меньше лимитов
						return true
					}
					// если это простой тариф
					else
					{
						// нужно что бы подходило по всем параметрам
						if (_data.cpu.value >= this.curTemplate.limits.cpu.min &&
							_data.disk.value >= this.curTemplate.limits.disk.min &&
							_data.ram.value >= this.curTemplate.limits.ram.min)
						{
							// тариф поддерживает шаблон
							return true
						}
						else
						{
							return false
						}
					}
				}
				// лимитов нет - значит сразу подходит
				else
				{
					return true
				}
			}

			// нет в списке поддерживаемых тарифов
			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// возвращает DOM-элемент слайдера
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		getDomSlider(name) {
			if (!name || !name.length) return null

			let _slider = null
			let _name = 'slider-' + name

			if (this.$refs && this.$refs[_name])
			{
				if (Array.isArray(this.$refs[_name]) && this.$refs[_name].length)
				{
					_slider = this.$refs[_name][0]
				}
				else
				{
					_slider = this.$refs[_name]
				}
			}

			return _slider
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// были ли изменения в конструкторе
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isContructorWasChanged() {
			if (!this.params || !this.params[this.curValue]) return false

			// ищем хотя бы один измененный параметр
			for (let prop in this.params[this.curValue])
			{
				let param = this.params[this.curValue][prop]
				// если вообще нет начальных значений - изменяться нечему
				if (!('__initValue' in param)) return false
				// если значения не совпадают - нашли
				if (param.__initValue !== param.value) return true
			}

			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// изменение значения в слайдере
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		sliderDragging(planItem, obj, value) {
			// если текущий тариф не выбран
			if (!this.curValue) return
			// если нет данных или заблокировано
			if (!planItem || !planItem.id || !planItem.enable) return
			if (!obj || !obj.__prop) return

			// установим значение в текстовом поле
			this.inputFieldValues[obj.__prop] = value

			// проверка и корректировка значений
			this.checkSliderValues(planItem, obj)

			// обнуляем таймер
			if (this.sliderTimerHandler)
			{
				clearTimeout(this.sliderTimerHandler)
			}
			// сразу заряжаем по новой таймер
			this.sliderTimerHandler = setTimeout(() => {
				this.sliderChangeHandler(planItem, obj, this.inputFieldValues[obj.__prop])
				// нужно запустить пересчет и для других слайдеров - если еще такого не делали
				if (this.action === 'view' && !this.isSlidersWasRecounted)
				{
					this.isSlidersWasRecounted = true

					for (let p in this.params[planItem.id])
					{
						let o = this.params[planItem.id][p]
						if (o.__prop !== obj.__prop)
						{
							this.sliderChangeHandler(planItem, o, this.inputFieldValues[o.__prop])
						}
					}
				}
			}, 200)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// пересчет изменившихся значений в слайдере
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		sliderChangeHandler(planItem, obj, value) {
			// если текущий тариф не выбран
			if (!this.curValue) return

			// если нет данных или заблокировано
			if (!planItem || !planItem.id || !planItem.enable) return

			// эмуляция фокуса
			this.$emit('focus')

			// проверка и корректировка значений
			this.checkSliderValues(planItem, obj)

			// был изменен конструктор
			EventBus.$emit('w5-plan-constructor-changed', this.isContructorWasChanged())

			// обновим кеш конструктора
			if (this.params && this.params[this.curValue])
				this.paramsCached[this.curValue] = Object.assign({}, this.params[this.curValue])

			// сообщаем всем что поменялся тариф
			this.handleEvent()

			// запоминаем новое значение
			this.curValue = String(planItem.id)
			// сообщаем родителю что у нас поменялось значение по тарифу
			this.$emit('input', this.curValue)
			// сообщаем родителю что у нас поменялось значение по тарифу
			this.$emit('params', this.params[planItem.id])

			// делаем обновление так как данные не "плоские"
			this.$forceUpdate()
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// проверка значений, и установка в рамках границ
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		checkSliderValues(planItem, obj) {
			// проверяем значения зависимых слайдеров
			// если поменялось значение у "cpu" или "ram"
			if (obj && (obj.__prop === 'cpu' || obj.__prop === 'ram'))
			{
				// получим текущие значения
				let ramValue = 0.0
				let cpuValue = 0.0
				let ramForCpu = 0
				let cpuMin = 1
				let ramMin = 1
				let cpuMax = -1
				let ramMax = -1

				// данные для прилипания
				let _Pow2 = [2, 4, 8, 12, 16, 20, 24, 32, 36, 48, 52, 54, 64, 68, 72, 78, 82, 84, 88, 92, 96, 128, 132, 148, 192, 200, 224, 248, 256, 300, 320, 360, 420, 480, 512, 640, 1024]

				// объекты
				let ramField = this.findParamsField(planItem, 'ram')
				let cpuField = this.findParamsField(planItem, 'cpu')

				if (obj.__prop === 'ram')
				{
					ramForCpu = parseFloat(obj.ram_for_cpu)
					if (isNaN(ramForCpu)) ramForCpu = 0.0

					ramValue = parseFloat(obj.value)
					if (isNaN(ramValue)) ramValue = 0.0

					ramMin = parseFloat(obj.min)
					if (isNaN(ramMin)) ramMin = 1.0

					ramMax = parseInt(obj.max)
					if (isNaN(ramMax)) ramMax = -1

					if (cpuField)
					{
						cpuValue = parseFloat(cpuField.value)
						if (isNaN(cpuValue)) cpuValue = 0.0

						cpuMin = parseFloat(cpuField.min)
						if (isNaN(cpuMin)) cpuMin = 1.0

						cpuMax = parseInt(cpuField.max)
						if (isNaN(cpuMax)) cpuMax = -1
					}
				}
				else if (obj.__prop === 'cpu')
				{
					cpuValue = parseFloat(obj.value)
					if (isNaN(cpuValue)) cpuValue = 0.0

					cpuMin = parseFloat(obj.min)
					if (isNaN(cpuMin)) cpuMin = 1.0

					cpuMax = parseInt(obj.max)
					if (isNaN(cpuMax)) cpuMax = -1

					if (ramField)
					{
						ramForCpu = parseFloat(ramField.ram_for_cpu)
						if (isNaN(ramForCpu)) ramForCpu = 0.0

						ramValue = parseFloat(ramField.value)
						if (isNaN(ramValue)) ramValue = 0.0

						ramMin = parseFloat(ramField.min)
						if (isNaN(ramMin)) ramMin = 1.0

						ramMax = parseInt(ramField.max)
						if (isNaN(ramMax)) ramMax = -1
					}
				}

				// прилипание - cpu
				// если меняют значения manualSliderChanged = true - то прилипание не нужно
				if (cpuValue > 2 && cpuValue > cpuMin && !this.manualSliderChanged)
				{
					// делаем копию значений
					let pow2 = _Pow2.slice()
					// добавим максимальное значение
					if (cpuMax > 0 && pow2.indexOf(cpuMax) < 0)
					{
						pow2.push(cpuMax)
					}

					// ищем ближайщее меньшее целое
					for (let l = 1; l < pow2.length; l++)
					{
						// нашли границы
						if (pow2[l - 1] < cpuValue && cpuValue < pow2[l])
						{
							// к какой границе ближе
							let _len = pow2[l] - pow2[l - 1]
							let _proc = _len > 20 ? 25 : 35
							let _reqDelta = Math.ceil(_len * _proc / 100.0)
							let _deltaLow = cpuValue - pow2[l - 1]
							let _deltaHigh = pow2[l] - cpuValue
							let _newValue = -1

							if (_deltaLow < _reqDelta)
							{
								_newValue = pow2[l - 1]
							}
							else if (_deltaHigh < _reqDelta)
							{
								_newValue = pow2[l]
							}

							if (_newValue > -1)
							{
								// сразу меняем все
								cpuValue = _newValue
								if (cpuField)
								{
									cpuField.value = cpuValue
									let _slider = this.getDomSlider('cpu')
									if (_slider && _slider.setValue)
									{
										_slider.setValue(cpuValue)
									}
								}
							}

							break
						}
					}
				}

				// прилипание - ram
				// если меняют значения manualSliderChanged = true - то прилипание не нужно
				if (ramValue > 2 && ramValue > ramMin && !this.manualSliderChanged)
				{
					// делаем копию значений
					let pow2 = _Pow2.slice()
					// добавим максимальное значение
					if (ramMax > 0 && pow2.indexOf(ramMax) < 0)
					{
						pow2.push(ramMax)
					}

					// ищем ближайщее меньшее целое
					for (let l = 1; l < pow2.length; l++)
					{
						// нашли границы
						if (pow2[l - 1] < ramValue && ramValue < pow2[l])
						{
							// к какой границе ближе
							let _len = pow2[l] - pow2[l - 1]
							let _proc = _len > 20 ? 20 : 30
							let _reqDelta = Math.ceil(_len * _proc / 100.0)
							let _deltaLow = ramValue - pow2[l - 1]
							let _deltaHigh = pow2[l] - ramValue
							let _newValue = -1
							if (_deltaLow < _reqDelta)
							{
								_newValue = pow2[l - 1]
							}
							else if (_deltaHigh < _reqDelta)
							{
								_newValue = pow2[l]
							}

							if (_newValue > -1)
							{
								// сразу меняем все
								ramValue = _newValue
								if (ramField)
								{
									ramField.value = ramValue
									let _slider = this.getDomSlider('ram')
									if (_slider && _slider.setValue)
									{
										_slider.setValue(ramValue)
									}
								}
							}

							break
						}
					}
				}

				//this.manualSliderChanged = false

				// проверка на границы
				if (ramValue < ramMin)
				{
					// сразу меняем все
					ramValue = ramMin
					if (ramField)
					{
						ramField.value = ramValue
						let _slider = this.getDomSlider('ram')
						if (_slider && _slider.setValue)
						{
							_slider.setValue(ramValue)
						}
					}
				}

				if (cpuValue < cpuMin)
				{
					// сразу меняем все
					cpuValue = cpuMin
					if (cpuField)
					{
						cpuField.value = cpuValue
						let _slider = this.getDomSlider('cpu')
						if (_slider && _slider.setValue)
						{
							_slider.setValue(cpuValue)
						}
					}
				}

				// если меняют "cpu"
				if (obj.__prop === 'cpu')
				{
					// сначала копируем значения в текстовые поля как есть
					this.inputFieldValues[obj.__prop] = cpuValue

					// считаем сколько должно быть "ram"
					let ramMustBe = cpuValue * ramForCpu
					// если значение "ram" меньше границы (больше может быть)
					if (ramValue < ramMustBe)
					{
						// двигаем значение "ram"
						if (ramField)
						{
							ramField.value = ramMustBe
							let _slider = this.getDomSlider('ram')
							if (_slider && _slider.setValue)
							{
								_slider.setValue(ramMustBe)
							}

							// копируем значения в текстовые поля
							this.inputFieldValues['ram'] = ramMustBe
						}
					}
				}
				// если меняют "ram"
				else if (obj.__prop === 'ram')
				{
					// сначала копируем значения в текстовые поля как есть
					this.inputFieldValues[obj.__prop] = ramValue

					// считаем сколько должно быть "cpu"
					let cpuMustBe = Math.floor(ramValue / ramForCpu)
					if (isNaN(cpuMustBe) || cpuMustBe <= 0)
						cpuMustBe = cpuMin

					// если значение "cpu" меньше границы
					if (cpuValue > cpuMustBe)
					{
						// двигаем значение "cpu"
						if (cpuField)
						{
							cpuField.value = cpuMustBe
							let _slider = this.getDomSlider('cpu')
							if (_slider && _slider.setValue)
							{
								_slider.setValue(cpuMustBe)
							}

							// копируем значения в текстовые поля
							this.inputFieldValues['cpu'] = cpuMustBe
						}
					}
				}
			}

			// у остальных просто проверяем на минимум
			if (obj && (obj.__prop !== 'cpu' && obj.__prop !== 'ram'))
			{
				// получим текущие значения
				let _Value = 0.0
				let _Min = 1
				let _Max = 1

				// получаем значения
				_Value = parseFloat(obj.value)
				if (isNaN(_Value)) _Value = 0.0

				_Min = parseFloat(obj.min)
				if (isNaN(_Min)) _Min = 1.0

				_Max = parseFloat(obj.max)
				if (isNaN(_Max)) _Max = 1.0

				// сначала копируем значения в текстовые поля как есть
				this.inputFieldValues[obj.__prop] = _Value

				// флаг - нужно ли менять значение
				let _changeValue = false

				// прилипание
				if (obj.__prop === 'disk' && _Value > _Min)
				{
					let _val = Math.floor(_Value / 10) * 10
					if (_val !== _Value)
					{
						_changeValue = true
						_Value = _val
					}
				}

				// проверка на границы
				if (_Value < _Min)
				{
					// сразу меняем все
					_changeValue = true
					_Value = _Min
				}

				if (_changeValue)
				{
					// объект
					let _Field = this.findParamsField(planItem, obj.__prop)
					if (_Field)
					{
						_Field.value = _Value
						let _slider = this.getDomSlider(obj.__prop)
						if (_slider && _slider.setValue)
						{
							_slider.setValue(_Value)
						}

						this.inputFieldValues[obj.__prop] = _Value
					}
				}
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// изменение значения в чекбоксе
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		booleanChangeHandler(planItem, obj) {
			// если текущий тариф не выбран
			if (!this.curValue) return

			// эмуляция фокуса
			this.$emit('focus')
			// если нет данных или заблокировано
			if (!planItem || !planItem.enable) return

			obj.value = !Helper.normalizeBooleanValue(obj.value)

			// обновим кеш конструктора
			if (this.params && this.params[this.curValue])
				this.paramsCached[this.curValue] = Object.assign({}, this.params[this.curValue])

			// был изменен конструктор
			EventBus.$emit('w5-plan-constructor-changed', this.isContructorWasChanged())

			// запоминаем новое значение
			this.curValue = String(planItem.id)
			// сообщаем родителю что у нас поменялось значение по тарифу
			this.$emit('input', this.curValue)
			// сообщаем родителю что у нас поменялось значение по тарифу
			this.$emit('params', this.params[planItem.id])

			// делаем обновление так как данные не "плоские"
			this.$forceUpdate()
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// поиск поля определенного параметра тарифа
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		findParamsField(item, fieldName) {
			if (!fieldName ||
				!this.params ||
				!item ||
				!item.id ||
				!this.params[item.id])
			{
				return null
			}

			for (let prop in this.params[item.id])
			{
				let data = this.params[item.id][prop]
				if (data && data.__prop === fieldName)
				{
					return data
				}
			}

			return null
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// итоговое значение по тарифу-конструктору
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		paramsPlanItogo(item, priceField = 'cost', withFormat = true) {
			if (!item || !item.params ||
				!item.params.cpu ||
				!item.params.ram ||
				!item.params.disk)
			{
				return ''
			}

			// минимальная стоимость тарифа
			let planCost = parseFloat(item[priceField])
			if (isNaN(planCost)) planCost = 0.0

			// вычисляем добавленную стоимость
			let sum = 0.0

			// бежим по всем параметрам конструктора
			for (let prop in item.params)
			{
				// данные параметра
				let data = item.params[prop]
				if (!data || !data.type) continue

				// стоимость за еденицу
				let costEd = parseFloat(data[priceField])
				if (isNaN(costEd)) costEd = 0.0

				// ищем соответствующее поле
				let field = this.findParamsField(item, prop)
				if (field)
				{
					if (data.type === 'slider')
					{
						// получим текущее количество
						let value = parseFloat(field.value)
						if (isNaN(value)) value = 0.0

						// убриаем минимумы - так как они уже включены в минимальную стоимость
						value = value - field.__initMin
						if (value < 0) value = 0.0

						// теперь можем посчитать
						sum += value * costEd
					}
					else if (data.type === 'boolean' && Helper.normalizeBooleanValue(field.value))
					{
						sum += costEd
					}
				}
			}

			let ipCost = 0
			if (this.ipInfo && this.ipInfo.ip4)
			{
				// стоимость за еденицу
				let costEd = parseFloat(this.ipInfo.ip4[priceField])
				if (isNaN(costEd)) costEd = 0.0

				// получим текущее количество
				let value = parseFloat(this.ipInfo.ip4['count'])
				if (isNaN(value)) value = 0.0

				// суммируем
				ipCost += value * costEd
			}

			if (this.ipInfo && this.ipInfo.ip6)
			{
				// стоимость за еденицу
				let costEd = parseFloat(this.ipInfo.ip6[priceField])
				if (isNaN(costEd)) costEd = 0.0

				// получим текущее количество
				let value = parseFloat(this.ipInfo.ip6['count'])
				if (isNaN(value)) value = 0.0

				// суммируем
				ipCost += value * costEd
			}

			if (!withFormat) return (planCost + sum + ipCost)

			sum = Helper.FormatMoney2(planCost + sum + ipCost, 2)
			return Helper.String2Money(sum)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// итоговое значение по плану-конструктору
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		minRangeWidthStyle(obj) {
			let min = 1
			let minRangeValue = 1
			if ('min' in obj)
			{
				minRangeValue = parseFloat(obj.min)
				if (isNaN(minRangeValue)) minRangeValue = 1
			}

			let max = 1
			if ('max' in obj)
			{
				max = parseFloat(obj.max)
				if (isNaN(max) || max === 0) max = 1
			}

			let total = max - min
			if (isNaN(total) || total === 0) total = 1
			let rangeValue = minRangeValue - min

			return 'width: ' + (rangeValue / total * 100.0) + '%'
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// изменение значения слайдера в текстовом поле
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onSliderFieldChange($input) {
			// если текущий тариф не выбран
			if (!this.curValue) return

			let value = $input.autoNumeric('get')
			let itemId = $input.data('itemId')
			let objProp = $input.data('obj')

			if (!value || !value.length) return

			let _field = this.findParamsField({ id: itemId }, objProp)
			if (_field)
			{
				// получим значение в текстовом поле
				let _value = parseInt(value, 10)

				if (isNaN(_value) || _value < _field.min) _value = _field.min
				if (_value > _field.max) _value = _field.max

				// обновим значение в состоянии
				_field.value = _value
				this.inputFieldValues[objProp] = _field.value

				// проверяем значения зависимых слайдеров
				// если поменялось значение у "cpu" или "ram"
				if (objProp === 'cpu' || objProp === 'ram')
				{
					// получим текущие значения
					let ramValue = 0.0
					let cpuValue = 0.0
					let ramForCpu = 0
					let cpuMin = 1
					let ramMin = 1

					// объекты
					let ramField = this.findParamsField({ id: itemId }, 'ram')
					let cpuField = this.findParamsField({ id: itemId }, 'cpu')
					let obj = _field

					if (obj.__prop === 'ram')
					{
						ramForCpu = parseFloat(obj.ram_for_cpu)
						if (isNaN(ramForCpu)) ramForCpu = 0.0

						ramValue = parseFloat(obj.value)
						if (isNaN(ramValue)) ramValue = 0.0

						ramMin = parseFloat(obj.min)
						if (isNaN(ramMin)) ramMin = 1.0

						if (cpuField)
						{
							cpuValue = parseFloat(cpuField.value)
							if (isNaN(cpuValue)) cpuValue = 0.0

							cpuMin = parseFloat(cpuField.min)
							if (isNaN(cpuMin)) cpuMin = 1.0
						}
					}
					else if (obj.__prop === 'cpu')
					{
						cpuValue = parseFloat(obj.value)
						if (isNaN(cpuValue)) cpuValue = 0.0

						cpuMin = parseFloat(obj.min)
						if (isNaN(cpuMin)) cpuMin = 1.0

						if (ramField)
						{
							ramForCpu = parseFloat(ramField.ram_for_cpu)
							if (isNaN(ramForCpu)) ramForCpu = 0.0

							ramValue = parseFloat(ramField.value)
							if (isNaN(ramValue)) ramValue = 0.0

							ramMin = parseFloat(ramField.min)
							if (isNaN(ramMin)) ramMin = 1.0
						}
					}

					// проверка на границы
					if (ramValue < ramMin)
					{
						// сразу меняем все
						ramValue = ramMin
						if (ramField)
						{
							ramField.value = ramValue
							let _slider = this.getDomSlider('ram')
							if (_slider && _slider.setValue)
							{
								_slider.setValue(ramValue)
							}
						}
					}

					if (cpuValue < cpuMin)
					{
						// сразу меняем все
						cpuValue = cpuMin
						if (cpuField)
						{
							cpuField.value = cpuValue
							let _slider = this.getDomSlider('cpu')
							if (_slider && _slider.setValue)
							{
								_slider.setValue(cpuValue)
							}
						}
					}

					// если меняют "cpu"
					if (obj.__prop === 'cpu')
					{
						// текстового поля
						this.inputFieldValues[obj.__prop] = cpuValue
						// считаем сколько должно быть "ram"
						let ramMustBe = cpuValue * ramForCpu
						// если значение "ram" меньше границы (больше может быть)
						if (ramValue < ramMustBe)
						{
							// двигаем значение "ram"
							if (ramField)
							{
								ramField.value = ramMustBe
								let _slider = this.getDomSlider('ram')
								if (_slider && _slider.setValue)
								{
									_slider.setValue(ramMustBe)
								}

								// текстового поля
								this.inputFieldValues['ram'] = ramMustBe
							}
						}
					}
					// если меняют "ram"
					else if (obj.__prop === 'ram')
					{
						// текстового поля
						this.inputFieldValues[obj.__prop] = ramValue
						// считаем сколько должно быть "cpu"
						let cpuMustBe = Math.floor(ramValue / ramForCpu)
						if (isNaN(cpuMustBe) || cpuMustBe <= 0)
							cpuMustBe = cpuMin

						// если значение "cpu" меньше границы
						if (cpuValue > cpuMustBe)
						{
							// двигаем значение "cpu"
							if (cpuField)
							{
								cpuField.value = cpuMustBe
								let _slider = this.getDomSlider('cpu')
								if (_slider && _slider.setValue)
								{
									_slider.setValue(cpuMustBe)
								}

								// текстового поля
								this.inputFieldValues['cpu'] = cpuMustBe
							}
						}
					}
				}

				// был изменен конструктор
				EventBus.$emit('w5-plan-constructor-changed', this.isContructorWasChanged())

				// обновим кеш конструктора
				if (this.params && this.params[this.curValue])
					this.paramsCached[this.curValue] = Object.assign({}, this.params[this.curValue])

				// сообщаем всем что поменялся тариф
				this.handleEvent()
				// сообщаем родителю что у нас поменялось значение по тарифу
				this.$emit('params', this.params[itemId])
				// делаем обновление так как данные не "плоские"
				this.$forceUpdate()
			}
		},

		onSliderFieldChangeNew(objProp, itemId) {
			// если текущий тариф не выбран
			if (!this.curValue) return

			// текущее значение
			const value = this.inputFieldValues[objProp]

			// ищем поле в моделях
			let _field = this.findParamsField({ id: itemId }, objProp)
			// если не нашли
			if (!_field) return

			// снова проверяем на ошибки
			if (isNaN(value))
			{
				this.inputFieldErrors[objProp] = 'validators/error_int'
				this.inputFieldValues[objProp] = value
				return
			}

			/*
			// если пустое - ничего не делаем, пустое значение будет обработано в событии "blur"
			if (!value) return
			*/
			// если значение пустое
			if (!value)
			{
				// проверим минимум - если он при этом не нулевой
				if (_field.min > 0)
				{
					return
				}
			}

			// проверка границ
			if (value < _field.min || value > _field.max)
			{
				this.inputFieldErrors[objProp] = 'Min: ' + _field.min + ', Max: ' + _field.max
				return
			}

			// проверки пройдены - обновим значение в состоянии
			_field.value = value

			// проверяем значения зависимых слайдеров
			// если поменялось значение у "cpu" или "ram"
			if (objProp === 'cpu' || objProp === 'ram')
			{
				// получим текущие значения
				let ramValue = 0.0
				let cpuValue = 0.0
				let ramForCpu = 0
				let cpuMin = 1
				let ramMin = 1

				// объекты
				let ramField = this.findParamsField({ id: itemId }, 'ram')
				let cpuField = this.findParamsField({ id: itemId }, 'cpu')
				let obj = _field

				if (obj.__prop === 'ram')
				{
					ramForCpu = parseFloat(obj.ram_for_cpu)
					if (isNaN(ramForCpu)) ramForCpu = 0.0

					ramValue = parseFloat(obj.value)
					if (isNaN(ramValue)) ramValue = 0.0

					ramMin = parseFloat(obj.min)
					if (isNaN(ramMin)) ramMin = 1.0

					if (cpuField)
					{
						cpuValue = parseFloat(cpuField.value)
						if (isNaN(cpuValue)) cpuValue = 0.0

						cpuMin = parseFloat(cpuField.min)
						if (isNaN(cpuMin)) cpuMin = 1.0
					}
				}
				else if (obj.__prop === 'cpu')
				{
					cpuValue = parseFloat(obj.value)
					if (isNaN(cpuValue)) cpuValue = 0.0

					cpuMin = parseFloat(obj.min)
					if (isNaN(cpuMin)) cpuMin = 1.0

					if (ramField)
					{
						ramForCpu = parseFloat(ramField.ram_for_cpu)
						if (isNaN(ramForCpu)) ramForCpu = 0.0

						ramValue = parseFloat(ramField.value)
						if (isNaN(ramValue)) ramValue = 0.0

						ramMin = parseFloat(ramField.min)
						if (isNaN(ramMin)) ramMin = 1.0
					}
				}

				// если меняют "cpu"
				if (obj.__prop === 'cpu')
				{
					// считаем сколько должно быть "ram"
					let ramMustBe = cpuValue * ramForCpu
					// если значение "ram" меньше границы (больше может быть)
					if (ramValue < ramMustBe)
					{
						// двигаем значение "ram"
						if (ramField)
						{
							ramField.value = ramMustBe
							let _slider = this.getDomSlider('ram')
							if (_slider && _slider.setValue)
							{
								this.manualSliderChanged = true
								_slider.setValue(ramMustBe)
							}

							// текстового поля
							this.inputFieldValues['ram'] = ramMustBe
						}
					}
				}
				// если меняют "ram"
				else if (obj.__prop === 'ram')
				{
					// считаем сколько должно быть "cpu"
					let cpuMustBe = Math.floor(ramValue / ramForCpu)
					if (isNaN(cpuMustBe) || cpuMustBe <= 0)
						cpuMustBe = cpuMin

					// если значение "cpu" меньше границы
					if (cpuValue > cpuMustBe)
					{
						// двигаем значение "cpu"
						if (cpuField)
						{
							cpuField.value = cpuMustBe
							let _slider = this.getDomSlider('cpu')
							if (_slider && _slider.setValue)
							{
								this.manualSliderChanged = true
								_slider.setValue(cpuMustBe)
							}

							// текстового поля
							this.inputFieldValues['cpu'] = cpuMustBe
						}
					}
				}
			}

			// был изменен конструктор
			EventBus.$emit('w5-plan-constructor-changed', this.isContructorWasChanged())

			// обновим кеш конструктора
			if (this.params && this.params[this.curValue])
				this.paramsCached[this.curValue] = Object.assign({}, this.params[this.curValue])

			// сообщаем всем что поменялся тариф
			this.handleEvent()
			// сообщаем родителю что у нас поменялось значение по тарифу
			this.$emit('params', this.params[itemId])
			// делаем обновление так как данные не "плоские"
			this.$forceUpdate()
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// текстовое поле слайдера потеряло фокус
		// тут нужно восстановить значение только в DOM - не в состоянии
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onSliderFieldBlur($input) {
			// если текущий тариф не выбран
			if (!this.curValue) return

			// получим значение
			let value = $input.val()

			// если значение пустое - восстановим из поля
			if (!value || !value.length)
			{
				let itemId = $input.data('itemId')
				let objProp = $input.data('obj')
				let _field = this.findParamsField({ id: itemId }, objProp)
				if (_field)
				{
					this.inputFieldValues[objProp] = _field.value
					this.inputFieldErrors[objProp] = ''
					$input.autoNumeric('set', _field.value)
				}
			}
		},

		onSliderFieldBlurNew(objProp, itemId) {
			const _field = this.findParamsField({ id: itemId }, objProp)
			if (!_field) return

			// если значения в поле нет или значение в поле ошибочное
			if (!this.inputFieldValues[objProp] || this.inputFieldErrors[objProp])
			{
				// если это просто нулевое значение без ошибки
				if (Number(this.inputFieldValues[objProp]) === 0 && !this.inputFieldErrors[objProp])
				{
					// если это в рамках минимума - ничего делать не нужно
					if (_field.min <= 0)
					{
						return
					}
				}

				// уберем ошибку
				this.inputFieldErrors[objProp] = ''

				// установим значение с учетом границ
				let _newValue = _field.value
				if (this.inputFieldValues[objProp] <= _field.min) _newValue = _field.min
				if (this.inputFieldValues[objProp] >= _field.max) _newValue = _field.max

				_field.value = _newValue

				// восстановим старое значение
				this.inputFieldValues[objProp] = _field.value
				let $input = $(this.$refs['field-' + objProp])
				if ($input && $input.length && $input.autoNumeric)
				{
					$input.autoNumeric('set', _field.value)
				}
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// изменение значения в поле ввода калькулятора
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onInputFieldChanged($input) {
			let value = $input.autoNumeric('get')
			let itemId = $input.data('itemId')
			let objProp = $input.data('obj')

			// обнулим ошибку
			this.inputFieldErrors[objProp] = ''

			// получим значение в текстовом поле
			let _value = parseInt(value, 10)
			if (isNaN(_value))
			{
				this.inputFieldErrors[objProp] = 'validators/error_int'
				this.inputFieldValues[objProp] = value
				return
			}

			// обновим значение в состоянии
			this.inputFieldValues[objProp] = _value

			// ищем поле в моделях
			let _field = this.findParamsField({ id: itemId }, objProp)

			/*
			// если значение пустое - ничего не делаем, пустое значение будет обработано в событии "blur"
			if (!value || !value.length) return
			*/
			// если значение пустое
			if (!value || !value.length)
			{
				// проверим минимум - если он при этом не нулевой
				if (_field && _field.min > 0)
				{
					return
				}
			}

			// если нашли указанное поле в моделях
			if (_field)
			{
				// проверка границ
				if (_value < _field.min || _value > _field.max)
				{
					this.inputFieldErrors[objProp] = 'Min: ' + _field.min + ', Max: ' + _field.max
					return
				}
			}

			// теперь можно обновить с дебаунсом
			this.onSliderFieldChangeNew(objProp, itemId)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// навешивание обработчиков на поля слайдеров
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		setHandlesOld() {
			// ссылка на текуший контекст компонента
			let _this = this

			// для каждого текстового поля слайдера
			$('.slider-input-field').each(function(idx) {
				// если оно еще не инициализоровано плагином
				if (!$(this).data('autoNumeric'))
				{
					// инициализируем
					$(this).autoNumeric('init', { aSep: '', mDec: 0 })
					// вешаем обработчик на нажатие клавишы
					$(this).off('keydown').on('keydown', (e) => {
						var text = $(this)[0]
						var t = text.value.substr(text.selectionStart, text.selectionEnd - text.selectionStart)
						if (t && t.length)
						{
							$(this).val('')
						}

						if ($(this).val().length >= 5)
						{
							e.preventDefault()
							return false
						}
					})
					// вешаем обработчик на поднятие клавишы
					$(this).off('keyup').on('keyup', (e) => {
						let value = $(this).autoNumeric('get')
						let itemId = $(this).data('itemId')
						let objProp = $(this).data('obj')

						if (!value || !value.length) return

						let _field = _this.findParamsField({ id: itemId }, objProp)
						if (_field)
						{
							// получим значение в текстовом поле
							let _value = parseInt(value, 10)

							if (isNaN(_value) || _value < _field.min) _value = _field.min
							if (_value > _field.max) _value = _field.max

							// обновим значение в состоянии
							_this.inputFieldValues[objProp] = _value
						}

						_this.onSliderFieldChange($(this))
					})
					// вешаем обработчик на блюр
					$(this).off('blur').on('blur', (e) => {
						_this.onSliderFieldBlur($(this))
					})
				}
			})
		},

		// new version
		setHandles() {
			// ссылка на текуший контекст компонента
			let _this = this

			// для каждого текстового поля слайдера
			$('.slider-input-field').each(function(idx) {
				// если оно еще не инициализоровано плагином
				if (!$(this).data('autoNumeric'))
				{
					// инициализируем
					$(this).autoNumeric('init', { aSep: '', mDec: 0, vMin: 0, vMax: 9999 })

					// вешаем обработчик на нажатие клавишы
					$(this).off('keydown').on('keydown', (e) => {
						var text = $(this)[0]
						var t = text.value.substr(text.selectionStart, text.selectionEnd - text.selectionStart)
						if (t && t.length)
						{
							$(this).val('')
						}
					})

					// навешиваем обработчик на изменение значения
					// в данном случае модуль "autoNumeric" уже обрабатывает событие "input"
					// поэтому тут мы ловим событие "keyup"
					$(this).off('keyup').on('keyup', () => {
						_this.onInputFieldChanged($(this))
					})
				}
			})
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// есть ли скидка в ip-адресах
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isDiscountIp() {
			if (!this.ipInfo) return false

			// ip4
			if (this.ipInfo.ip4)
			{
				// проверка параметров
				if (isNaN(Number(this.ipInfo.ip4.cost)) || isNaN(Number(this.ipInfo.ip4.full_cost))) return false

				// если общая цена не равна
				if (Number(this.ipInfo.ip4.cost).toFixed(6) !== Number(this.ipInfo.ip4.full_cost).toFixed(6)) return true
			}

			// ip6
			if (this.ipInfo.ip6)
			{
				// проверка параметров
				if (isNaN(Number(this.ipInfo.ip6.cost)) || isNaN(Number(this.ipInfo.ip6.full_cost))) return false

				// если общая цена не равна
				if (Number(this.ipInfo.ip6.cost).toFixed(6) !== Number(this.ipInfo.ip6.full_cost).toFixed(6)) return true
			}

			// ответ по умолчанию
			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// есть ли скидка в тарифе
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isDiscountPlan(item) {
			// проверка параметров
			if (!item) return false
			if (!('cost' in item) || !('full_cost' in item)) return false
			if (isNaN(Number(item.cost)) || isNaN(Number(item.full_cost))) return false

			// если общая цена не равна
			if (Number(item.cost).toFixed(6) !== Number(item.full_cost).toFixed(6)) return true

			// если это конструктор
			if (item.has_params && item.params)
			{
				// дополнительно проверим параметры
				if (Number(item.params.cpu.cost).toFixed(6) !== Number(item.params.cpu.full_cost).toFixed(6)) return true
				if (Number(item.params.ram.cost).toFixed(6) !== Number(item.params.ram.full_cost).toFixed(6)) return true
				if (Number(item.params.disk.cost).toFixed(6) !== Number(item.params.disk.full_cost).toFixed(6)) return true
				if (item.params.ip4)
				{
					if (Number(item.params.ip4.cost).toFixed(6) !== Number(item.params.ip4.full_cost).toFixed(6)) return true
				}
			}

			// ответ по умолчанию
			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// есть ли скидка в параметре тарифа-конструктора
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isDiscountParam(item) {
			// проверка параметров
			if (!item) return false
			if (!('cost' in item) || !('full_cost' in item)) return false

			if (item.type === 'slider')
			{
				let value = (Number(item.value) - item.__initMin) <= 0
					? 0
					: (Number(item.value) - item.__initMin)

				if (isNaN(value) || value === 0) return false
			}

			if (item.type === 'boolean')
			{
				let value = Boolean(item.value) === false
					? 0
					: 1

				if (isNaN(value) || value === 0) return false
			}

			// если общая цена не равна
			if (item.cost !== item.full_cost) return true

			// ответ по умолчанию
			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// формирует объект с базовыми значениями для тарифа
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		planBaseValues(item) {
			if (!item || !item.id || !item.data || !this.params[item.id])
				return {}

			let _obj = {}
			for (let prop in item.data)
			{
				_obj[prop] = {}
				_obj[prop].title = item.data[prop].title
				_obj[prop].for = item.data[prop].for
				_obj[prop].value = item.data[prop].value

				for (let n in this.params[item.id])
				{
					let param = this.params[item.id][n]
					if (param.__prop === prop)
					{
						_obj[prop].title = param.title
						_obj[prop].for = param.for
						_obj[prop].value = param.__initMin
						break
					}
				}
			}

			return _obj
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// видим ли итог по определенному пункту
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isVisibleParamsItog(obj) {
			if (!obj || !obj.type) return false
			if (obj.type === 'boolean' && obj.value) return true
			if (obj.type === 'slider')
			{
				return (Number(obj.value) - obj.__initMin) > 0
			}
			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// видим ли хотя бы один итог
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		isVisibleAnyParamsItog(data) {
			for (let p in data)
			{
				if (this.isVisibleParamsItog(data[p])) return true
			}

			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// выбрали один из тарифов-конструкторов
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onSeveralConstructorSelect(id, enable, Item, event) {
			event.preventDefault()

			// эмуляция фокуса
			this.$emit('focus')

			// если заблокировано
			if (!enable) return

			// проверка флагов
			if (Item.enable === false || !this.isPlanSupportedByTemplate(Item.id))
				return

			// обновим кеш конструктора
			if (this.params && this.params[this.curValue])
				this.paramsCached[this.curValue] = Object.assign({}, this.params[this.curValue])

			// запомним старое значение
			let oldValue = this.curValue

			// копирование параметров из одного конструктора в другой
			this.copyParamsFromConstructor(String(id), oldValue)

			/*
			// запоминаем новое значение
			this.curValue = String(id)

			// копируем значение из старого конструктора в новый
			// по тем полям которые есть в новом конструкторе
			if (this.params && this.params[oldValue] && this.params[this.curValue])
			{
				// бежим по всем параметрам старого конструктора
				for (let idx in this.params[oldValue])
				{
					// текущий параметр старого конструктора
					const param = this.params[oldValue][idx]
					if (!param || !param.__prop) continue

					// имя параметра
					const name = param.__prop

					// бежим по всем параметрам нового конструктора
					for (let jdx in this.params[this.curValue])
					{
						// текущий параметр нового конструктора
						const _param = this.params[this.curValue][jdx]
						if (!_param || !_param.__prop) continue

						// имя параметра
						const _name = _param.__prop

						// если нашли такой же параметр в новом конструкторе
						if (name === _name)
						{
							// если это слайдер
							if (_param.type === 'slider' &&
								('min' in _param) && ('max' in _param))
							{
								// проверим границы
								// min: если значение в старом конструкторе меньше минимального значения в новом
								if (param.value < _param.min)
								{
									// значит будем минимум
									_param.value = _param.min
								}
								// max: если значение в старом конструкторе больше максимального значения в новом
								else if (param.value > _param.max)
								{
									// значит будем максимум
									_param.value = _param.max
								}
								// если в границах - просто копируем значение
								else
								{
									_param.value = param.value
								}

								// обновим значение в текстовом поле
								this.inputFieldValues[_name] = _param.value
							}
							else
							{
								// просто копируем значение
								_param.value = param.value
							}

							// на этом все
							break
						}
					}
				}
			}
			*/

			// сообщаем родителю что у нас поменялось значение по тарифу
			this.$emit('input', this.curValue)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// копирование параметров из одного конструктора в другой
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		copyParamsFromConstructor(newValue, oldValue, needUpdateCurValue = true) {
			// обновим новое значение только если потребовали
			if (needUpdateCurValue) this.curValue = String(newValue)

			// актуальное значение
			const curValue = this.curValue

			// копируем значение из старого конструктора в новый
			// по тем полям которые есть в новом конструкторе
			if (this.params && this.params[oldValue] && this.params[curValue])
			{
				// бежим по всем параметрам старого конструктора
				for (let idx in this.params[oldValue])
				{
					// текущий параметр старого конструктора
					const param = this.params[oldValue][idx]
					if (!param || !param.__prop) continue

					// имя параметра
					const name = param.__prop

					// бежим по всем параметрам нового конструктора
					for (let jdx in this.params[curValue])
					{
						// текущий параметр нового конструктора
						const _param = this.params[curValue][jdx]
						if (!_param || !_param.__prop) continue

						// имя параметра
						const _name = _param.__prop

						// если это не такой же параметр в новом конструкторе
						if (name !== _name) continue

						// если это слайдер
						if (_param.type === 'slider' &&
							('min' in _param) && ('max' in _param))
						{
							// проверим границы
							// min: если значение в старом конструкторе меньше минимального значения в новом
							if (param.value < _param.min)
							{
								// значит будем минимум
								_param.value = _param.min
							}
							// max: если значение в старом конструкторе больше максимального значения в новом
							else if (param.value > _param.max)
							{
								// значит будем максимум
								_param.value = _param.max
							}
							// если в границах - просто копируем значение
							else
							{
								_param.value = param.value
							}

							// обновим значение в текстовом поле
							this.inputFieldValues[_name] = _param.value
						}
						else
						{
							// просто копируем значение
							_param.value = param.value
						}

						// на этом все
						break
					}
				}
			}
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		// если изменился список - перегрузили его
		'items': function(items, old) {
			// инициализируем, только если список изменился
			if (!Helper.arrayCompare(items, old))
			{
				this.initValue()
			}
		},

		// если изменилась группа
		groupValue(value) {
			this.curGroup = this.formater_StrToInt(value)
		},

		// если изменилось значение (текущий тариф)
		value(value, old) {
			// если это мультиконструктор
			if (this.isSeveralConstructors && this.curGroup)
			{
				// сразу запомним какой тариф был выбран из списка тарифов
				this.currentMultiConstructorValue[this.curGroup] = this.curValue
			}

			// копирование параметров из одного конструктора в другой
			this.copyParamsFromConstructor(String(value), old, false)

			// если это просмотр VDS
			if (this.action === 'view')
			{
				// по идее - уже должно быть задано значение родителем
				if (value) this.curValue = String(value)
			}
		}
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		VueSlider
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-vds-plan-list-block {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;
}

.w5-vds-plan-list-block.template {
	margin-top: 0;
}

.w5-vds-plan {
	padding: 0 !important;
	margin-top: 0;
}

.w5-vds-plan > div.template-wrapper,
.w5-vds-plan > div.plan-wrapper {
	margin-top: 20px;
}

.w5-vds-plan > div.template-wrapper.in-view {
	margin-top: 15px;
	margin-bottom: 10px;
}
.w5-vds-plan > div.plan-wrapper.in-view {
	margin-top: 10px;
}

@media (max-width: 767px) {
	.w5-vds-plan {
		padding: 0 !important;
	}
}

.w5-vds-plan-list-item {
	margin: 10px 0;
	margin-right: 15px;
	margin-bottom: 10px;
    width: 160px;
    height: 148px;
    border: 0px;
    background-color: white;
    text-align: center;
    font-size: 85%;
    cursor: pointer;
}
.w5-vds-plan-list-item:last-of-type {
	margin-right: 0;
}

.w5-vds-plan-list-item.ssl {
	width: 150px;
	height: auto;
}

.w5-vds-plan-list-item.groups {
	width: 90px;
	margin: 20px 15px 0 0;
}

.w5-vds-plan-list-item.groups:last-of-type {
	margin: 20px 0 0 0;
}

.w5-vds-plan-list-item.outer-disks {
	width: 120px;
	height: 120px;
	margin: 20px 15px 0 0;
}

/* курсор над невыделенным тарифом */
.w5-vds-plan-list-item:hover div.w5-vds-plan-list-item-up {
	background-color: #dceeff !important;
    border-color: #3ba3ff !important;
    color: black;
}
.w5-application.mc .w5-vds-plan-list-item:hover div.w5-vds-plan-list-item-up {
    border-color: #1b379c !important;
}

.w5-vds-plan-list-item:hover div.w5-vds-plan-list-item-down {
    border-color: #3ba3ff !important;
}
.w5-application.mc .w5-vds-plan-list-item:hover div.w5-vds-plan-list-item-down {
    border-color: #1b379c !important;
}

/* выделенный тариф */
.w5-vds-plan-list-item.selected div.w5-vds-plan-list-item-up {
	background-color: #dceeff !important;
    border-color: #2c8ad8 !important;
    color: black;
}
.w5-application.mc .w5-vds-plan-list-item.selected div.w5-vds-plan-list-item-up {
    border-color: #01196f !important;
}

.w5-vds-plan-list-item.selected div.w5-vds-plan-list-item-down {
    border-color: #2c8ad8 !important;
}
.w5-application.mc .w5-vds-plan-list-item.selected div.w5-vds-plan-list-item-down {
    border-color: #01196f !important;
}

/* курсор над выделенным тарифом */
.w5-vds-plan-list-item.selected:hover div.w5-vds-plan-list-item-up {
	background-color: #dceeff !important;
    border-color: #3ba3ff !important;
    color: black;
}
.w5-application.mc .w5-vds-plan-list-item.selected:hover div.w5-vds-plan-list-item-up {
    border-color: #1b379c !important;
}

.w5-vds-plan-list-item.selected:hover div.w5-vds-plan-list-item-down {
    border-color: #3ba3ff !important;
}
.w5-application.mc .w5-vds-plan-list-item.selected:hover div.w5-vds-plan-list-item-down {
    border-color: #1b379c !important;
}

/* недоступный тариф */
.w5-vds-plan-list-item.disabled {
	cursor: not-allowed;
}
.w5-vds-plan-list-item.disabled div.w5-vds-plan-list-item-up {
	background-color: #eee !important;
    border-color: #ccc !important;
    color: #aaa;
}

.w5-vds-plan-list-item.disabled div.w5-vds-plan-list-item-down {
    border-color: #ccc !important;
    color: #ccc;
}

/* недоступный выделенный тариф */
.w5-vds-plan-list-item.selected.disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.w5-vds-plan-list-item.selected.disabled div.w5-vds-plan-list-item-up {
	background-color: #2c8ad8 !important;
    border-color: #2c8ad8 !important;
    color: white;
}
.w5-application.mc .w5-vds-plan-list-item.selected.disabled div.w5-vds-plan-list-item-up {
	background-color: #01196f !important;
    border-color: #01196f !important;
}

.w5-vds-plan-list-item.selected.disabled div.w5-vds-plan-list-item-down {
    border-color: #2c8ad8 !important;
}
.w5-application.mc .w5-vds-plan-list-item.selected.disabled div.w5-vds-plan-list-item-down {
    border-color: #01196f !important;
}

.w5-vds-plan-list-item-up {
	border: 1px solid #ddd !important;
    color: black;
    padding: 10px;
    border-radius: 4px 4px 0 0 !important;
    transition: background-color .2s;
    transition: border-color .2s;
}

.w5-vds-plan-list-item-up img.local-group {
	width: 50px;
	height: 50px;
}

.w5-vds-plan-list-item-up img.local-group.disks {
	filter: invert(86%) sepia(9%) saturate(15%) hue-rotate(13deg) brightness(95%) contrast(90%);
}
.w5-vds-plan-list-item-up img.local-group.disks.selected {
	filter: invert(56%) sepia(27%) saturate(5027%) hue-rotate(184deg) brightness(87%) contrast(94%);
}
.w5-vds-plan-list-item-up img.local-group.disks.selected.macloud {
	filter: invert(8%) sepia(49%) saturate(7032%) hue-rotate(228deg) brightness(89%) contrast(108%);	
}





.w5-vds-plan-list-item-down {
	position: relative;
	border-bottom: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
    border-left: 1px solid #ddd !important;
    padding: 13px 5px;
    color: black;    
    border-radius: 0 0 4px 4px !important;
    transition: border-color .2s;
}

.w5-vds-plan-list-item-down.template_id.border-none {
	border-width: 0 !important;
}

.w5-vds-plan-list-item.groups > .w5-vds-plan-list-item-down {
	padding: 10px 2px;
	font-size: 12px;

	height: 76px;
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;
	align-items: center;
	-webkit-align-items: center;
	justify-content: center;
	-webkit-justify-content: center;
}

.w5-component-field-title {
	position: relative;
	font-weight: 400;	
	top: 5px;
}

.w5-vds-plan-list-filter-wrapper.plan {
	margin: 0;
}
.w5-vds-plan-list-filter-wrapper.plan .description {
	margin-top: 10px;
	font-size: 13px;
	font-weight: 300;
	line-height: 1;
}
.w5-vds-plan-list-filter-wrapper.plan .description p {
	margin: 0;
}

.w5-vds-plan-not-active {
	opacity: 0.5;
}

@media (max-width: 380px) {
	.w5-vds-plan-list-filter-wrapper.plan .description {
		font-size: 11px;
	}
}

.construct-plan {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	/*min-height: 320px;*/
	width: 100%;
	margin-top: 0;
}
.construct-plan.multi-construct {
	margin-top: 20px;
}
.construct-plan.disabled {
	opacity: 0.6;
}
.construct-plan.in-view {
	margin-top: -15px;
}

.construct-plan > div.fields-values {
	padding: 0;
}
.construct-plan > div.fields-divider {
	padding: 0;
	margin: 0;
	border-left: 1px solid #ddd;
	width: 20px;
}
.construct-plan > div.itogo-values {
	padding: 0;
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;
	flex-direction: column;
}

.construct-plan > div.itogo-values > .values > .header {
	font-size: 16px;
	font-weight: 500;
	color: #000;
}
.construct-plan > div.itogo-values > .values > .itog-item {
	padding: 8px 0;
	border-bottom: 1px solid #ddd;
	display: flex;
	max-width: 310px;
	justify-content: space-between;
}
.construct-plan > div.itogo-values > .values > .itog-item.without-border {
	border-color: transparent;
}
.construct-plan > div.itogo-values > .values > .itog-item > div {
	display: inline-block;
	font-size: 12px;
	font-weight: 400;
	color: #666;
}
.construct-plan > div.itogo-values > .values > .itog-item > div.title {
	width: 160px;
}

.construct-plan > div.itogo-values > .values > .itog-item > div.value {
	display: inline-block;
	width: 120px;
	text-align: right;
}
.construct-plan > div.itogo-values > .values > .itog-item > div.value > .sm {
	position: relative;
	display: inline-block;
	font-weight: 500;
	color: #333;
}

.construct-plan > div.itogo-values > .values > .itog-item.add-cost {
	font-size: 12px;
	font-weight: 400;
	margin-top: 20px;
}
.construct-plan > div.itogo-values > .values > .itog-item.base-cost {
	flex-direction: column;
}
.construct-plan > div.itogo-values > .values > .itog-item.base-cost > div {
	display: block;
}
.construct-plan > div.itogo-values > .values > .itog-item.base-cost > div > .title {
	display: inline-block;
	font-size: 12px;
	font-weight: 400;
	color: #666;
	width: 160px;
}
.construct-plan > div.itogo-values > .values > .itog-item.base-cost > div > .value {
	display: inline-block;
	width: 120px;
	text-align: right;
}
.construct-plan > div.itogo-values > .values > .itog-item.base-cost > div > .value > .sm {
	position: relative;
	display: inline-block;
	font-weight: 500;
	color: #333;
}
/*
.construct-plan span.sm > span.full-cost,
.construct-plan div.itogo > span.full-cost,
.w5-vds-plan-list-item span.full-cost,
span.price-with-discount > strong:first-of-type {
	position: absolute;
	top: -12px;
	display: inline-block;
	text-decoration: line-through;
	font-size: 85%;
	color: #999;
}
*/
.construct-plan span.sm > span.full-cost,
.construct-plan div.itogo > div.value > span.full-cost,
.w5-vds-plan-list-item span.full-cost,
span.price-with-discount > strong:first-of-type {
	position: absolute;
	top: -12px;
	display: inline-block;
	font-size: 85%;
	color: #999;
	white-space: nowrap;
}

.construct-plan span.sm > span.full-cost:after,
.construct-plan div.itogo > div.value > span.full-cost:after,
.w5-vds-plan-list-item span.full-cost:after,
span.price-with-discount > strong:first-of-type:after {
	border-top: 1px solid #999;
    position: absolute;
    content: "";
    right: 0;
    top: 48%;
    left: 0;
}

.construct-plan span.sm > span.full-cost {
	top: -10px;
}
.construct-plan span.sm > span.full-cost:after {
	top: 40%;
}
.construct-plan div.itogo > div.value > span.full-cost {
	top: -13px;
}
.w5-vds-plan-list-item span.full-cost {
	top: 2px;
}
span.price-with-discount > strong:first-of-type:after {
	top: 45%;
}

.w5-vds-plan-list-item.disabled span.full-cost {
	color: #ccc;
}
.w5-vds-plan-list-item.disabled span.full-cost:after {
	border-color: #ccc;
}

span.price-with-discount {
	position: relative;
}
span.price-with-discount > p:first-of-type {
	display: inline-block;
	margin: 0;
	font-weight: 500;
}

.construct-plan > div.itogo-values > .itogo {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: space-between;
	-webkit-justify-content: space-between;

	position: relative;
	margin-top: 12px;
	padding: 4px 0;
	font-size: 15px;
	font-weight: 400;
	color: #000;
}

.w5-vds-plan-list-params-base {
	display: block;
	margin: 0;
	color: #999;
	font-size: 12px;
}

.w5-vds-plan-list-params-base > div.title {
	font-weight: 500;
}

.w5-vds-plan-list-params-base > div.values {
	font-size: 11px;
	font-weight: 300;
}

.w5-vds-plan-list-params-item {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;
}

.w5-vds-plan-list-params-item > .graph-slider {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: center;
	-webkit-justify-content: center;
	align-items: center;
	margin-bottom: 60px;
}

.w5-vds-plan-list-params-item > .graph-slider > .title {
	width: 100px;
	font-weight: 400;
	font-size: 15px;
	line-height: 1;
	color: #000;
	word-wrap: anywhere;
}
.w5-vds-plan-list-params-item > .graph-slider > .text-slider {
	position: relative;
}
.w5-vds-plan-list-params-item > .graph-slider > .slider {
	position: relative;
	width: 200px;
}
.w5-vds-plan-list-params-item > .graph-slider > .text-slider > .text-slider-field-wrapper > .field-postfix-wrapper {
    top: 5px;
    font-size: 12px;
}
.w5-vds-plan-list-params-item > .graph-slider > .text-slider > .text-slider-field-error {
	display: block;
	position: absolute;
	border-radius: 4px;
	color: red;
	background-color: #fec8c1;
	border: 1px solid #fe9c8f;
	font-size: 11px;
	font-weight: 300;
	padding: 4px 8px;
	margin-top: 6px;
	margin-bottom: 0;
	z-index: 13;
}
.w5-vds-plan-list-params-item > .graph-slider > .text-slider > .text-slider-field-error::before,
.w5-vds-plan-list-params-item > .graph-slider > .text-slider > .text-slider-field-error::after {
	content: '';
	position: absolute;
	left: 20px;
	top: -9px;
	border: 4px solid transparent;    
	border-bottom: 4px solid #fe9c8f;
}
.w5-vds-plan-list-params-item > .graph-slider > .text-slider > .text-slider-field-error::after {
	top:  -7px;
	border-bottom: 4px solid #fec8c1;
}
.w5-vds-plan-list-params-item.itogo > .graph-slider > .slider {
	height: auto;
}
.w5-vds-plan-list-params-item > .graph-slider > .slider > .itogo-title {
	float: right;
	font-weight: 200;
	font-size: 13px;
}
.w5-vds-plan-list-params-item > .graph-slider > .value {
	margin-left: 20px;
	width: 100px;
	font-weight: 500;
	font-size: 13px;
}

.w5-vds-plan-list-params-item > .graph-slider > .cost {
	position: relative;
	margin-left: 15px;
	font-weight: 400;
	font-size: 12px;
	min-width: 100px;
}

.w5-vds-plan-list-params-item > .checkbox.params {
	margin-top: 0;
	margin-bottom: 0;
}
.w5-vds-plan-list-params-item > .checkbox.params .w5-boolean-label .cost {
	margin-left: 10px;
	font-weight: 500;
	color: #999;
}

.w5-vds-plan-list-params-item > .graph-slider > .slider .vue-slider-process {
    background-color: #2c8ad8
}
.w5-application.mc .w5-vds-plan-list-params-item > .graph-slider > .slider .vue-slider-process {
    background-color: #01196f
}
.w5-vds-plan-list-params-item > .graph-slider > .slider .vue-slider-mark-label {
	top: 0
}

.slider-input-field {
	padding: 4px 8px !important;
	padding-right: 20px !important;
	height: auto !important;
	width: 105px !important;
	font-size: 14px !important;
	font-weight: 500 !important;
	margin-right: 20px !important;
}

.slider-input-field.has-error {
	transition: all 0.3s;
	border-color: red;
	box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(233, 102, 102, 0.6);
}

.process-minimum {
	position: absolute;
	height: 100%;
	width: 0;
	background-color: #fdcdcd;
	z-index: 1;
	top: 0;
}

@media (max-width: 470px) {
	.w5-vds-plan-list-params-item > .graph-slider > .text-slider {
		width: 80% !important;
	}
}

@media (max-width: 768px) {
	.w5-vds-plan-list-params-item > .graph-slider > .slider {
		width: calc(100% - 20px);
		margin: 20px 7px 20px;
	}
	.w5-vds-plan-list-params-item > .graph-slider > .cost {
		min-width: 90px;
		margin-left: 0;
	}

	.w5-vds-plan-list-params-item > .graph-slider > .title {
		width: 100%;
		padding: 10px 0 6px;
	}

	.w5-vds-plan-list-params-item > .graph-slider > .text-slider {
		width: 50%;
	}

	.slider-input-field {
		width: 100% !important;
		margin-right: 0 !important;
		padding-right: 40px !important;
		height: 40px !important;
	}

	.w5-vds-plan-list-params-item > .graph-slider > .text-slider > .text-slider-field-wrapper > .field-postfix-wrapper {
		right: 8px !important;
		top: 11px;
	}

	.construct-plan > div.itogo-values > .values > .itog-item > div.title {
		width: 100%;
	}
	.construct-plan > div.itogo-values > .values > .itog-item > div.value {
		width: auto;
		text-align: left;
	}
	.construct-plan > div.itogo-values > .itogo {
		font-size: 15px;
		text-align: left;
	}

	.w5-vds-plan-list-params-item > .graph-slider {
		flex-direction: column;
  		width: 100%;
  		align-items: flex-start;
		justify-content: center;
		-webkit-justify-content: center;
	}

	.construct-label {
		flex-direction: column;
		align-items: flex-start !important;
		justify-content: center;
		-webkit-justify-content: center;
	}

	.params-boolean-hint {
		margin-left: 0 !important;
		margin-top: 5px;
	}
}

@media (max-width: 1115px) {
	.construct-plan {
		flex-direction: column;
	}
	.construct-plan > div.fields-values {
		padding: 10px 0 20px 0;
		border-bottom: 2px solid #ddd;
	}
	.construct-plan > div.fields-divider {
		display: none;
	}
	.construct-plan > div.itogo-values {
		padding: 10px 0;
	}
	.construct-plan > div.itogo-values > .values > .itog-item {
		padding: 10px 0;
		max-width: none;
	}
	.construct-plan > div.itogo-values > .values > .itog-item > div.title {
		width: 100px;
	}
	.construct-plan > div.itogo-values > .values > .itog-item > div.value {
		width: calc(100% - 120px);
		text-align: right;
	}
	.construct-plan > div.itogo-values > .values > .itog-item.base-cost > div > .title {
		font-size: 10px;
		width: calc(100% - 120px);
	}
	.construct-plan > div.itogo-values > .itogo {
		text-align: right;
		padding: 10px 0;
		max-width: none;
	}
}

.params-boolean-hint {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;

	color: #999;
	margin-left: 10px;
	font-size: 11px;
}

.itog-item-base-cost {
	display: flex !important;
	justify-content: space-between !important;
}

.w5-vds-plan-list-filter-wrapper.create,
.w5-vds-plan-list-filter-wrapper.view {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	align-items: center;
	-webkit-align-items: center;
}

.w5-vds-plan-list-filter {
	display: inline-block;
	text-align: left;
	font-weight: 400;
	padding-bottom: 5px;
	cursor: pointer;
	font-size: 15px;
	transition: color .2s;
	margin-right: 20px;
	line-height: 1;
}
.w5-vds-plan-list-filter:hover {
	color: #3ba3ff;
}
.w5-application.mc .w5-vds-plan-list-filter:hover {
	color: #1b379c;
}

.w5-vds-plan-list-filter.last {
	margin-left: 0;
	margin-right: 0;
}
.w5-vds-plan-list-filter.active {
	color: #2c8ad8;
	border-bottom: 2px solid #2c8ad8;
}
.w5-application.mc .w5-vds-plan-list-filter.active {
	color: #01196f;
	border-bottom: 2px solid #01196f;
}

.w5-vds-plan-list-filter.disabled {
	color: #999 !important;
	cursor: not-allowed !important;
}
.w5-vds-plan-list-filter.disabled:hover {
	color: #999 !important;
}
.w5-vds-plan-list-filter.active.disabled {
	border-color: #999 !important;
}

@media (max-width: 767px) {
	.w5-vds-plan-list-filter-wrapper.create,
	.w5-vds-plan-list-filter-wrapper.view {
		flex-direction: column;
		align-items: stretch;
		-webkit-align-items: stretch;
	}

	.w5-vds-plan-list-filter.last {
		margin-left: 0;
	}

	.w5-vds-plan-list-filter {
		font-size: 14px;
		text-align: left;
		margin-top: 10px;

		display: inline-block;
	}
}

</style>



// WEBPACK FOOTER //
// planNew.vue?3e796ca2